{
    "Api tokens": {
        "add token": "Pridėti prieigos raktą",
        "description": "Sugeneruoja API prieigos raktą OEM failo atsisiuntimui, skirtą TCT ir Konfigūratoriui arba API prieigos raktą, skirtą naudoti FOTA WEB paslaugoms. API dokumentaciją galite rasti <1>čia</1>.",
        "example": "Pvz.: fota_token",
        "generate token": "Generuoti prieigos raktą",
        "generated token": "Sugeneruotas prieigos raktas",
        "last used at": "Paskutinį kartą naudotas",
        "name": "Prieigos rakto pavadinimas",
        "never": "Niekada",
        "no tokens": "Prieigos raktų nėra",
        "no tokens description": "Kai tik prieigos raktai bus sugeneruoti, jų sąrašą galėsite matyti čia",
        "show token list": "Prieigos raktų sąrašas",
        "titles": {
            "Integration": {
                "description": "Naudojamas FOTA WEB integravimui į jūsų sistemą",
                "name": "API integracijos prieigos raktas"
            },
            "Tct": {
                "description": "Naudojamas OEM failų atsisiuntimui TCT ir Konfigūratoriuje",
                "name": "TCT prieigos raktas"
            }
        },
        "tokens": "API prieigos raktai",
        "token type": "Prieigos rakto tipas",
        "token was created": "Prieigos raktas sukurtas"
    },
    "Attributes": {
        "Completed": "Baigti žurnalo failai",
        "Count": "Iš viso žurnalo failų",
        "Current": "Dabartinis žurnalo failas",
        "Date": "Data",
        "Empty": "Tušti žurnalo failai",
        "excluded files": "Neįtraukti failai",
        "Failed": "Nepavykę žurnalo failai",
        "Feature": "Funkcija",
        "file size bytes": "Bendras failo dydis",
        "File_type": "Failo tipas",
        "File_version": "Failo versija",
        "Fingerprint_id": "Piršto atspaudo ID",
        "Firmware_date": "Prog. įrangos data",
        "Firmware_version": "Revizija",
        "included files": "Įtraukti failai",
        "Message": "Pranešimas",
        "Metadata": "Metaduomenys",
        "newest": "Nuo naujausio",
        "oldest": "Nuo seniausio",
        "Order": "Žurnalo failų eiliškumas",
        "Password_source": "Slaptažodžio šaltinis",
        "Pending": "Laukiantys žurnalo failai",
        "Period": "Laikotarpis",
        "Process_id": "Proceso ID",
        "Protocol_id": "Protokolo ID",
        "specific": "Pasirenkamieji",
        "Start": "Pradinis žurnalo failas",
        "SystemGenerated": "Automatiškai sukurtas slaptažodis",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "BLE programinė įranga",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "CAN programinė įranga",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "TAPP programinė įranga"
        },
        "UserEntered": "Naudotojo įvestas slaptažodis",
        "vehicle": "Transporto priemonė",
        "Vehicle_id": "Transporto priemonės ID",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "Pasitikrinkite autentifikavimo mobiliąją programėlę",
            "check email": "Pasitikrinkite savo el. paštą",
            "code required": "Reikalingas patvirtinimo kodas.",
            "code sent to email": "Kodas išsiųstas į jūsų el. paštą",
            "code valid": "Kodas galioja keletą minučių.",
            "enter code below": "ir įveskite gautą kodą.",
            "no access to otp": "Neturite prieigos prie savo įrenginio?",
            "recovery code": {
                "banner text": "Prisijungę naudodami atkūrimo kodą, būsite paprašyti iš naujo sukonfigūruoti dviejų veiksnių autentifikavimą, kad užtikrintumėte savo paskyros saugumą.",
                "description": "Įveskite vieną iš savo atkūrimo kodų, kad prisijungtumėte. Kiekvieną kodą galima naudoti tik vieną kartą.",
                "secondary text": "Įveskite vieną iš savo atkūrimo kodų, kad prisijungtumėte. Kiekvieną kodą galima naudoti tik vieną kartą.",
                "title": "Atkūrimo kodas"
            },
            "title": "Paskyros patvirtinimas",
            "use recovery code": "Naudoti atkūrimo kodą."
        },
        "account verification description": "Reikalingas patvirtinimo kodas. Patikrinkite autentifikavimo mobiliąją programėlę ir įveskite gautą kodą.",
        "check email": "Patikrinkite savo el. pašto dėžutę.",
        "community forum": "Bendruomenės forumas",
        "contact us": "Susisiekite su mumis",
        "create initial password": "Kurti slaptažodį",
        "create password": "Pasirinkite slaptažodį, kuris",
        "did not receive": "Negavote nuorodos?",
        "do not have account": "Dar neturite paskyros?",
        "email": "El. paštas",
        "enter email": "Įveskite savo el. pašto adresą.",
        "forgot password": "Pamiršote slaptažodį?",
        "forgot your password": "Pamiršote slaptažodį?",
        "for ms365": "Teltonika MS365 naudotojams",
        "invalid email format": "Netinkamas el. pašto adreso formatas",
        "invalid password format": "Netinkamas slaptažodžio formatas",
        "link sent": "Nuoroda išsiųsta!",
        "length": "Mažiausiai 8 simboliai",
        "lowercase": "apima bent vieną mažąją raidę",
        "new password": "Naujas slaptažodis",
        "password": "Slaptažodis",
        "passwords do not match": "Slaptažodžiai nesutampa",
        "privacy policy": "Naudodamiesi FOTA WEB, Jūs sutinkate su mūsų <1>privatumo politika</1>.",
        "remember password": "Prisimenate savo slaptažodį?",
        "repeat password": "Pakartokite slaptažodį",
        "required": "Būtinas",
        "resend": "Persiųsti",
        "reset password": "Atkurti slaptažodį",
        "send reset link": "Siųsti atkūrimo nuorodą",
        "sign in": "Prisijungti",
        "sign in to fota": "Prisijungite prie savo\nFOTA WEB paskyros",
        "signup": "Užsiregistruoti",
        "sso": "Prisijunkite naudodami Microsoft",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "Didžioji raidė",
        "user consent text": "Suprantu ir sutinku su Teltonikos <1>Paslaugų teikimo sąlygomis</1> ir <2>Duomenų tvarkymo sutartimi</2>.",
        "welcome": "Sveikiname prisijungus",
        "wiki": "Informacinė Wiki telematikos bazė"
    },
    "Banner": {
        "activate banner": "Aktyvuoti informacinį skydelį",
        "apply link": "Pritaikyti nuorodą",
        "banner importance": "Informacinio skydelio svarbos lygis",
        "bold": "Paryškintas",
        "close link": "Uždaryti nuorodą",
        "info": "Informacinis",
        "italic": "Kursyvas",
        "link": "Nuoroda",
        "message": "Pranešimas",
        "text": "Tekstas (nebūtina)",
        "underline": "Pabrauktas",
        "url": "URL",
        "warning": "Įspėjimas"
    },
    "Button": {
        "accept": "Priimti",
        "accept all": "Priimti viską",
        "accept selected": "Priimti pasirinktus",
        "actions": "Veiksmai",
        "add": "Pridėti",
        "add device": "Pridėti įrenginį",
        "add more files": "Pridėti daugiau failų",
        "add new": "Pridėti naują",
        "agree": "Sutinku",
        "all companies": "Visos įmonės",
        "all of company": "Visos {{companyName}} įmonės",
        "all rows selected": {
            "devices": "Visi įrenginiai ({{count}}) pasirinkti",
            "tasks": "Visos laukiančios/vykdomos užduotys ({{count}}) pasirinktos",
            "groups": "Visos grupės ({{count}}) pasirinktos",
            "files": "Visi failai ({{count}}) pasirinkti",
            "companies": "Visos įmonės ({{count}}) pasirinktos",
            "users": "Visi naudotojai ({{count}}) pasirinkti"
        },
        "approve": "Patvirtinti",
        "assign": "Priskirti",
        "assigning": "Priskiriama",
        "auto sync": "",
        "back": "Atgal",
        "back to sign in": "Atgal į prisijungimo langą",
        "cancel": "Atšaukti",
        "cancelling": "Atšaukiama",
        "cancel all tasks in group": "Atšaukti visas užduotis šioje grupėje",
        "cancel tasks": "Atšaukti užduotis",
        "cannot create desktop licenses": "Licencijos negali būti sukurtos vidinio tipo įmonėms.",
        "cannot create offline licenses": "Offline licencijos negali būti sukurtos neapribotoms licencijoms.",
        "change": "Pakeisti",
        "clear all": "Viską išvalyti",
        "clear all filters": "Išvalyti visus filtrus",
        "close": "Uždaryti",
        "company settings": "Įmonės nustatymai",
        "confirm": "Patvirtinti",
        "continue": "Tęsti",
        "copied": "Nukopijuota",
        "copy all": "Kopijuoti viską",
        "copy to clipboard": "Nukopijuoti į iškarpinę",
        "create": "Sukurti",
        "create role": "Sukurti vaidmenį",
        "create task": "Sukurti užduotį",
        "creating": "Kuriama",
        "default view": "Numatytasis vaizdas",
        "delete": "Naikinti",
        "deleting": "Naikinama",
        "deselect all": "Panaikinti visus pasirinkimus",
        "device": "Įrenginys",
        "disable": "Išjungti",
        "disagree": "Nesutinku",
        "discard": "Atmesti",
        "download": "Atsisiųsti",
        "edit": "Redaguoti",
        "enable": "Įjungti",
        "export": "Eksportuoti",
        "exporting": "Eksportuojama",
        "filters": "Filtrai",
        "finish": "Baigti",
        "find tool": "Radimo įrankis",
        "first page": "Pirmas puslapis",
        "fmx and legacy": "FMx ir Legacy",
        "ft platform": "FT platforma",
        "generate": "Generuoti",
        "generate codes": "Sukurti kodus",
        "go back": "Atgal",
        "import": "Importuoti",
        "importing": "Importuojama",
        "invite": "Pakviesti",
        "invite user": "Pakviesti naudotoją",
        "invite user to internal disabled": "Tik administratorius-vadovas ir kiti naudotojai, turintys aukštesnį prieigos lygį, gali pakviesti naudotojus į vidines įmones.",
        "language": "Kalba",
        "last page": "Paskutinis puslapis",
        "logout": "Atsijungti",
        "maximize details": "Išplėsti",
        "merge": "Sujungti",
        "merging": "Sujungiama",
        "minimize details": "Sumažinti",
        "more actions": "Daugiau veiksmų",
        "more filters": "Daugiau filtrų",
        "more options": "Daugiau pasirinkimų",
        "move": "Perkelti",
        "moving": "Perkeliama",
        "next": "Toliau",
        "next month": "Kitas mėnesis",
        "next page": "Kitas puslapis",
        "no actions available": "Nėra veiksmų",
        "no permission": "Jums reikia šio leidimo: \"{{permissionName}}\".",
        "no permissions": "Jums reikia šių leidimų: {{permissionNames}}.",
        "notify when done": "Pranešti man, kai veiksmas bus baigtas",
        "number of selected companies": "{{companyCount}} iš {{companyName}}",
        "only essential": "Tik būtini",
        "open fota web": "Įeiti į FOTA WEB",
        "pages of": "iš {{total}}",
        "previous month": "Ankstesnis mėnesis",
        "previous page": "Ankstesnis puslapis",
        "print": "Spausdinti",
        "receive devices": "Gauti įrenginius",
        "refresh page": "Atnaujinti puslapį",
        "reject all": "Atmesti viską",
        "reset to default": "Atkurti numatytuosius",
        "retry failed tasks": "Pakartoti iš naujo nepavykusias užduotis",
        "retrying": "Kartojama",
        "return home": "Grįžti į pagrindinį puslapį",
        "revert manual level change": "Grąžinti rankinį lygio pakeitimą",
        "rows count per page": "Eilučių skaičius puslapyje",
        "rows selected": "Pasirinkta {{count}}",
        "save": "Išsaugoti",
        "saving": "",
        "see all": "Rodyti viską",
        "select all": {
            "devices": "Pasirinkti visus įrenginius ({{count}})",
            "tasks": "Pasirinkti visas laukiančias/vykdomas užduotis ({{count}})",
            "groups": "Pasirinkti visas grupes ({{count}})",
            "files": "Pasirinkti visus failus ({{count}})",
            "companies": "Pasirinkti visas įmones ({{count}})",
            "users": "Pasirinkti visus naudotojus ({{count}})"
        },
        "select columns to show": "Pasirinkti rodytinus stulpelius",
        "selected page is first": "Pasirinktas puslapis yra pirmas",
        "selected page is last": "Pasirinktas puslapis yra paskutinis",
        "select rows": "Pasirinkti eilutes",
        "send code": "Siųsti kodą",
        "settings": "Nuostatos",
        "show me": "Parodyti",
        "show more": "Rodyti daugiau",
        "synchronize": "Sinchronizuoti",
        "table statistics": "Statistika",
        "table view": "Lentelės nustatymai",
        "transfer": "Perduoti",
        "transferring": "Perduodama",
        "transfer my devices": "Perduoti savo įrenginius",
        "undo": "Anuliuoti",
        "upload": "Įkelti",
        "upload file": "Įkelti naują failą",
        "user": "Naudotojas",
        "verify": "Patvirtinti",
        "yes": "Taip"
    },
    "Cookies": {
        "always active": "Visada aktyvūs",
        "analytics cookies": "Analitikos slapukai",
        "analytics cookies description": "Šie stebėjimo įrenginiai naudojami analizei, siekiant padėti rinkti duomenis, leidžiančius suprasti, kaip naudotojai sąveikauja su mūsų svetainėmis. Šios įžvalgos leidžia patobulinti turinį ir sukurti geresnes funkcijas, kurios pagerina naudotojo patirtį. Šios kategorijos slapukai gali būti išjungti.",
        "cookie banner message": "Mes ir pasirinktos trečiosios šalys naudojame slapukus ar panašias technologijas techniniais ir, gavus jūsų sutikimą, kitais tikslais, kaip nurodyta ",
        "cookie modal title": "Mes naudojame slapukus",
        "cookie policy": "slapukų politikoje",
        "essential cookies": "Būtini slapukai",
        "essential cookies description": "Šie slapukai naudojami veiklai, kuri yra būtina norint veikti arba teikti paslaugas. Jie nerenka jokios informacijos apie jus, kuri galėtų būti naudojama rinkodaros tikslais ir neįsimena jūsų veiklos internete. Šios kategorijos slapukų išjungti negalima."
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "Įrenginio pagrindiniai nuotolinio atnaujinimo dalykai",
                "Standard": "Pažangi automatizacija ir integracija",
                "Premium": "Verslo plėtimas ir išankstinė prieiga prie naujinių"
            },
            "resource limit types": {
                "Companies": "Įmonės",
                "Users": "Naudotojai",
                "ConfigurationFiles": "Konfigūracijos failai"
            }
        },
        "empty state": {
            "description": {
                "configurations": "Kai tik FOTA WEB aptiks konfigūracijas, čia galėsite matyti jų sąrašą.",
                "firmware versions": "Kai tik FOTA WEB aptiks programinės įrangos versijas, čia galėsite matyti jų sąrašą."
            },
            "title": {
                "configurations": "Nerasta jokių konfigūracijų",
                "firmware versions": "Nerasta jokių programinės įrangos versijų",
                "news": "Nėra jokių naujienų"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "Šiandien",
                "7": "7 dienos",
                "30": "30 dienų",
                "90": "90 dienų"
            },
            "period": "Laikotarpis"
        },
        "new": "Nauja",
        "news": {
            "body": {
                "1": "Primename, kad naudotojams, pakviestiems po 2025 m. sausio 7 d., 2FA bus privalomas iš karto po paskyros aktyvavimo. Dviejų veiksnių autentifikavimas galimas patvirtinant el. paštu arba naudojant autentifikavimo programėlę.",
                "2": "Nuo birželio 3 d. 05:00 val. UTC (08:00 val. Lietuvos laiku), atliksime sistemos techninius priežiūros darbus, kurių metu visos FOTA WEB paslaugos bus neprieinamos apie 1 valandą. Prašome atsižvelgti į tai, kad techninės priežiūros metu bus neprieinamos visos paslaugos, įskaitant naudotojo sąsają, API prieigą, užduočių vykdymą, OBD ir CAN paslaugas. Atsiprašome už galimus nepatogumus.",
                "3": "<section><p>Džiaugiamės galėdami pranešti apie svarbų FOTA WEB įrenginių atrakinimo funkcijos patobulinimą, kuris leidžia visiems naudotojams tiesiogiai atrakinti įrenginius naudojantis FOTA WEB nesikreipiant į Teltonika techninę pagalbą! Šis atnaujinimas panaikina laukimo laiką ir suteikia daugiau galimybių kontroliuoti savo įrenginius.</p></section><section><p>Svarbi informacija:</p><ul><li>Naudotojai gali atrakinti tą patį įrenginį iki 3 kartų per 24 valandų laikotarpį.</li><li>Pasiekus įrenginio atrakinimo limitą, atrakinimo galimybė bus laikinai išjungta 24 valandoms.</li><li>Viršijus įrenginio atrakinimo limitą, bus rodomas klaidos pranešimas.</li></ul></section><section><a>Sužinokite, kaip naudotis šia funkcija</a></section>",
                "4": "<section><p>Džiaugiamės galėdami pranešti apie atnaujinimus \"FOTA WEB\" prietaisų skydelyje! Stengėmės pagerinti jūsų patirtį patobulintais valdikliais ir naujomis įžvalgomis.</p></section><section><h3>Nauja įrenginių statistika</h3><p>Gaukite geresnių įžvalgų apie savo įrenginių veiklą naudodami du visiškai naujus valdiklius:</p><p><strong>Aktyvuoti įrenginiai</strong>: ši statistika seka, kiek įrenginių buvo aktyvuotų (prisijungė) per nustatytą laikotarpį: šiandien, 7 dienos, 30 dienų arba 90 dienų.</p><p><strong>Importuoti įrenginiai</strong>: ši statistika rodo, kiek įrenginių buvo importuota per šiandien, 7 dienas, 30 dienų arba 90 dienų.</p></section><section><h3>Pristatome užduočių valdiklį</h3><p>Sekite savo operacijas naudodami visiškai naują užduočių valdiklį:</p><p><strong>Užduotys eilėje</strong>: matykite aiškų šiuo metu laukiančių užduočių skaičių.</p><p><strong>Užduočių apžvalga</strong>: gaukite užduočių pasiskirstymo pagal laikotarpį (7 dienas, 30 dienų ir 90 dienų) ir jų būseną. Tai apima užduotis, kurios yra atliktos, užbaigtos su klaidomis ir nepavykusios.</p></section><section><h3>Išmanesnės programinės įrangos ir konfigūracijų apžvalgos</h3><p>Patobulinome programinės įrangos versijų ir konfigūracijų valdiklius:</p><ul><li>Pašalinome \"Nežinomos\" statistikas, kad duomenys būtų aiškesni.</li><li>Naudotojo sąsaja dabar aiškiau rodo programinės įrangos versijos ir konfigūracijos pavadinimus bei jų skaičių.</li><li>Iš pradžių matysite 5 populiariausias programinės įrangos versijas ar konfigūracijas, su galimybe \"Rodyti daugiau\", kad peržiūrėtumėte iki 100 skirtingų įrašų.</li><li>Užvedus pelės žymeklį ir paspaudus ant konkrečios programinės įrangos versijos ar konfigūracijos, būsite nukreipti į \"Įrenginiai\" puslapį, kuriame bus pritaikytas filtras.</li></ul></section><section><h3>Patobulintas naujienų valdiklis</h3><p>Būkite iškart informuoti apie svarbiausias FOTA WEB naujienas! Naujienų valdiklis turi naują išvaizdą, dabar galite spustelėti bet kurią naujieną, kad perskaitytumėte visą informaciją.</p></section><section><h3>Patobulinta įrenginio būsenos valdiklis</h3><p>Įrenginio būsenos valdiklis buvo vizualiai atnaujintas, siekiant aiškumo. Be to, dabar galite užvesti pelės žymeklį ant įrenginio būsenos ir spustelėti ją, kad filtruotumėte įrenginius su atitinkama būsena \"Įrenginiai\" puslapyje.</p></section><section><p>Tikimės, kad šie atnaujinimai palengvins jūsų kasdienes užduotis ir suteiks daugiau vertingos informacijos. Praneškite mums, ką manote!</p></section>",
                "5": "<section><h3>Planuojami API pakeitimai</h3></section><section><p><strong>2025 m. rugsėjo 24 d.</strong> iš atsakymų, grąžinančių naudotojo entitetą (pavyzdžiui, GET /users arba GET /users/{userId} galiniai taškai), bus pašalintas laukas „role“. Šis pakeitimas daromas siekiant sudaryti sąlygas patikimesnei ir lankstesnei leidimų sistemai FOTA WEB.</p></section><section><h3>Pirmasis žvilgsnis: vaidmenys ir leidimai</h3></section><section><p>Suprantame, kad dabartinė vaidmenų sistema nesuteikia jums reikiamo lankstumo. Mūsų kūrimo komanda intensyviai dirba kurdama naują <strong>vaidmenų ir leidimų valdymo</strong> funkciją, kuri leis kurti vaidmenis su išsamiu leidimų valdymu.</p></section><section><p>Naujoji sistema suteiks galimybę priskirti naudotojams statinius vaidmenis arba pritaikyti leidimus pagal jūsų konkrečius poreikius bei kurti pasirinktinius vaidmenis. Labai džiaugiamės šia naujove ir nekantraujame pasidalyti daugiau informacijos apie vaidmenų ir teisių valdymą, kai ji taps prieinama.</p></section>",
                "6": "<section><p>Džiaugiamės galėdami pranešti apie naujos funkcijos <strong>\"Vaidmenys ir leidimai\"</strong> išleidimą, skirtą suteikti jums tikslią naudotojų prieigos kontrolę naudojant FOTA WEB. Ši funkcija leidžia jums apibrėžti naudotojų galimybes naudojant <strong>vaidmenis</strong>, kurie yra sudaryti iš konkrečių <strong>leidimų</strong> (pvz., \"Sukurti užduotį\", \"Pakviesti naudotoją\"). Funkcija apima nekintamus <strong>statinius vaidmenis</strong> pagrindiniam saugumui užtikrinti – administratoriaus, naudotojo ir svečio. Taip pat pritaikomus <strong>pasirinktinius vaidmenis</strong>, kuriuos gali kurti arba redaguoti tik <strong>Premium įmonės lygio</strong> naudotojai. Leidimai dabar suskirstyti į kategorijas pagal pagrindines sritis, tokias kaip įrenginiai, užduotys ir naudotojai, ir juos galima peržiūrėti užvedus pelės žymeklį ant \"Leidimų kiekis\" valdymo skiltyje. <strong>Visiems esamiems naudotojams, sukurtiems iki šio atnaujinimo, automatiškai priskirtas vaidmuo \"Administratorius\", užtikrinant, kad jie išlaikytų visus veiksmus, kuriuos galėjo atlikti anksčiau.</strong></p></section><section><p>Šis atnaujinimas užtikrina geresnį saugumą ir darbo krūvio paskirstymą. Vaidmenys yra skirti konkrečiai įmonei ir negali būti paveldimi tarp įmonės struktūrų. Atminkite, kad kviečiant arba perkeliant naudotoją į įmonę, vaidmuo visada turi būti priskirtas ir vaidmenų su aktyviais naudotojų priskyrimais negalima ištrinti. Taip pat dabar galite naudoti <strong>naują filtrą</strong> \"<strong>Vaidmuo</strong>\" puslapyje \"<strong>Naudotojai</strong>\", kad būtų lengviau valdyti priskirtus vaidmenis. Jau šiandien peržiūrėkite skyrių \"Vaidmenys ir leidimai\", kad sukonfigūruotumėte prieigą, pritaikytą jūsų organizacijos poreikiams.</p></section><section><p>Išsamią informaciją apie naudotojų ir vaidmenų valdymą rasite <a>wiki puslapyje</a>.</p></section>",
                "7": "<section><p>Džiaugiamės galėdami pristatyti galingą naują būdą valdyti jūsų užduotis su funkcija <strong>Suplanuoti užduotį pagal datą</strong>, suteikiančią jums didesnį tikslumą atliekant laiko atžvilgiu svarbius darbus!</p></section><section><h3>Svarbiausi akcentai</h3></section><section><ul><li><strong>Konkretūs terminai</strong> - Dabar galite planuoti užduotis <strong>konkrečiai datai arba datų intervalui</strong> naudodami naują parinktį „Suplanuoti užduotį pagal datą“.</li><li><strong>Nėra pakeista numatytoji veikla</strong> - Įprasta funkcija <strong>Suplanuoti užduotį pagal laiką</strong> lieka visiškai prieinama.</li><li><strong>Galiojimo pabaigos būsena</strong> - Užduotys, kurios nebuvo užbaigtos iki nustatytos datos, dabar automatiškai pakeis būseną į <strong>„Pasibaigęs galiojimas“</strong>, kartu su pranešimu: <strong>„Užduotis nebuvo užbaigta per nustatytą laikotarpį.“</strong></li><li><strong>Naudotojui pritaikytas laikas</strong> - Visi tvarkaraščiai sudaromi remiantis <strong>jūsų vietos laiku</strong>.</li></ul></section><section><h3>Kaip tai veikia</h3></section><section><p>Nustatant užduotį <strong>„Suplanuoti užduotį pagal datą“</strong>:</p><ul><li>Naudodami datų pasirinkimo komponentą, pasirinksite <strong>„Pradžios datą“</strong> ir <strong>„Pabaigos datą“</strong>.</li><li>Datų pasirinkimo komponentas atsižvelgia į įmonės lygio užduočių galiojimo terminą.</li></ul></section><section><p>Funkcija <strong>Suplanuoti užduotį pagal datą</strong> šiuo metu yra prieinama tik aukštesnio lygio įmonėms ir nėra prieinama <strong>Basic</strong> lygiui.</p></section>",
                "8": "<section><p>Atnaujinome jūsų administravimo įrankių rinkinį! Dabar galite valdyti visą naudotojo paskyros gyvavimo ciklą nuo pakvietimo momento iki galutinio galiojimo pabaigos, užtikrindami, kad jūsų įmonės duomenys išliktų saugūs, o prieiga būtų laikina, kai to reikia. </p></section><section><h3>Kas naujo?</h3></section><section><ul><li><strong>Laiko riboti pakvietimai</strong> – Nebebus numatyta „amžina prieiga“ pagal numatytuosius nustatymus. Nustatykite griežtą galiojimo pabaigos datą tuo momentu, kai pakviečiate naują komandos narį ar rangovą.</li><li><strong>Atgalinis galiojimo pabaigos taikymas</strong> – Lengvai pritaikykite galiojimo pabaigos datas naudotojams, kurie jau yra aktyvūs jūsų sistemoje</li><li><strong>Prieigos nutraukimas pagal poreikį</strong> – Reikia nedelsiant panaikinti prieigą? Dabar galite akimirksniu nutraukti bet kurio naudotojo prieigą. Jei reikės ją atkurti, naudotoją galėsite suaktyvinti iš naujo dviem spustelėjimais – neribotam laikui arba nustatydami naują galiojimo pabaigos laiką.</li></ul><p><strong>Kodėl tai svarbu</strong>: Ši funkcija puikiai tinka išorės rangovų ar laikino personalo valdymui, nes nereikia prisiminti vėliau rankiniu būdu ištrinti jų paskyras.</p></section><section><h3> Būkite informuoti </h3></section><section><p> Mes pridėjome išmanųjį pranešimų lygmenį, kad nei jūs, nei jūsų naudotojai niekada neliktumėte nežinioje. Dabar sistema siunčia automatinius el. laiškus:</p><ol><li> <strong>Įspėjimas</strong>: Siunčiamas likus nedaug laiko iki prieigos galiojimo pabaigos. </li><li><strong>Perėjimas</strong>: Siunčiamas tuo momentu, kai prieiga baigiasi. </li><li><strong>Sveikinimo laiškas</strong>: Siunčiamas iškart po paskyros reaktyvavimo. </li></ol></section><section><h3>Kaip valdyti prieigą</h3></section><section><p>Prieigą prie šių naujų nustatymų rasite <strong>Naudotojas</strong> puslapyje: </p><ul><li><strong>Kviečiant</strong>: Ieškokite „Galiojimo pabaigos datos“.</li><li><strong> Esamiems nadotojams</strong>: Spustelėkite „Redaguoti“ prie bet kurio naudotojo, kad pakeistumėte jo prieigos trukmę.</li><li><strong>Greitas veiksmas</strong>: Spustelėkite „Redaguoti“ prie bet kurio naudotojo ir ieškokite „Prieiga“ perjungimo mygtuko.</li></ul></section>",
                "9": "<section> <p> Džiaugiamės galėdami pranešti apie reikšmingą jūsų įrenginių parkų valdymo atnaujinimą. Mes užpildėme funkcinę spragą tarp mūsų platformų, perkeldami galingas <strong>įrenginių Smart Group</strong> funkcijas į <strong>FT platformą</strong>. Anksčiau automatinis failų platinimas buvo prabanga, kuria galėjo mėgautis daugiausia FMx naudotojai. Šiuo atnaujinimu mes pertvarkėme grupavimo logiką, kad užtikrintume nuoseklumą, automatizavimą ir aiškumą visoje jūsų ekosistemoje.</p></section><section><h3>Kas naujo? </h3></section><section><p>Mes atskyrėme standartines grupes nuo automatizuotų grupių, kad suteiktume jums daugiau kontrolės, kaip jūsų įrenginiai gauna atnaujinimus.</p><ul><li><strong>Įrenginių grupė (standartinė)</strong> - Paprastas būdas kategorizuoti ir organizuoti jūsų produktus. Šios grupės neturi pridėtų failų, todėl jos idealiai tinka pagrindiniam valdymui.</li><li><strong>Įrenginių Smart Group</strong> - Čia vyksta automatizavimas. Sukurdami Smart Group, galite pridėti konkrečius failus, kurie <strong>automatiškai išsiunčiami</strong> į kiekvieną tos grupės įrenginį.</li><li><strong>Kelių platformų palaikymas</strong> - Kurdami grupę, dabar galite pasirinkti „Sukurti Smart Group“. Šis perjungimas suteikia galimybę vienu metu įkelti ir valdyti specialius failus <strong>FT ir FMx platformoms</strong>.</li></ul></section><section><h3>Kodėl tai svarbu</h3></section><section><p>„Smart“ funkcija sukurta tam, kad sutaupytų jūsų laiko ir sumažintų žmogiškųjų klaidų skaičių:</p><ul><li><strong>Momentinis sinchronizavimas</strong> - Vos pridėjus naują įrenginį į Smart Group, sistema jį atpažįsta ir nedelsdama nusiunčia reikiamus failus.</li><li><strong>Lygybė</strong> - FT platformos naudotojai dabar turi tokias pačias patikimas automatizavimo priemones kaip ir FMx naudotojai, užtikrinančias vieningą darbo eigą nepriklausomai nuo to, kokią įrangą diegiate. </li> <li> <strong>Aiškumas</strong> - Atskirti „Įrenginių grupes“ nuo „Smart Groups“, dabar iš karto aišku, kurios grupės aktyviai siunčia duomenis į jūsų įrangą, o kurios yra grynai organizacinės. </li> </ul></section><section><h3>Kaip naudoti išmaniąsias grupes</h3> </section><section><p>Galite pradėti automatizuoti diegimą puslapyje <strong>„Įrenginių grupės\"</strong>:</p><ol><li><strong>Pasirinkite grupės tipą</strong> - Spustelėkite, kad sukurtumėte naują grupę, ir įjunkite parinktį <strong>„Sukurti Smart Group“</strong>.</li> <li><strong>Pridėkite failus</strong> - Jums bus pasiūlyta pridėti atitinkamus failus jūsų konkrečioms platformoms (FT arba FMx).</li><li><strong>Pridėkite įrenginius</strong> - Tiesiog perkelkite savo įrenginius į įrenginių grupę. Platforma pasirūpins likusiu, užtikrindama, kad kiekvienas įrenginys būtų atnaujintas.</li></ol></section>",
                "10": "<section><p>Informuojame, kad atnaujiname elektroninio pašto adresą, kurį naudoja <strong> FOTA WEB</strong> automatiniams sistemos pranešimams siųsti. Nuo <strong>2026 m. kovo 24 d.</strong> visa sistemos generuojama korespondencija bus perkelta į naują domeną.</p></section><section><h3>Kas keičiasi?</h3></section><section><p>Mes keičiame senąjį siuntėjo adresą į paprastesnį:</p><ul><li><strong>Senasis adresas:</strong> no-reply-fota@teltonika-iot-group.com </li><li> <strong> Naujas adresas: </strong> fota@teltonika-telematics.com </li></ul> </section><section><h3> Ką turėtumėte daryti? </h3> </section><section><p> Kad nepraleistumėte jokių svarbių saugumo kodų ar sistemos atnaujinimų, rekomenduojame atlikti šiuos veiksmus: </p> <ol> <li> <strong>Įtraukite naują adresą į leidžiamų adresų sąrašą</strong> - Įtraukite fota@teltonika-telematics.com į leidžiamų adresų sąrašą arba susisiekite su IT skyriumi, kad įsitikintumėte, jog naujas domenas yra leidžiamas jūsų organizacijos ugniasienėje.</li><li><strong>Atnaujinkite filtravimo taisykles</strong> - Jei savo pašto dėžutėje turite nustatytas automatines aplankų taisykles ar žymes, skirtas FOTA WEB, atnaujinkite jas, įtraukdami naują adresą.</li></ol></section><section><p> Iki kovo 24 d. išsiųsti laiškai vis dar bus rodomi iš senojo adreso. Dėl ankstesnės korespondencijos jokių veiksmų imtis nereikia. </p></section>",
                "11": "<section><p>Nuo <strong>2026 m. balandžio 9 d.</strong> atnaujiname savo saugumo protokolus, kad užtikrintume jūsų paskyros saugumą. Atsisakome slaptažodžių atkūrimo kaip dviejų faktorių autentifikavimo (2FA) atsarginės priemonės ir įvedame <strong>atkūrimo kodus</strong> kaip jūsų naują, saugų „atsarginį raktą“.</p></section><section><h3>Kas keičiasi?</h3></section><section><p>Anksčiau slaptažodžio atkūrimas galėjo būti naudojamas, siekiant apeiti prarastą 2FA įrenginį. Siekiant suderinti su geriausiomis pasaulinėmis saugumo praktikomis, ši galimybė bus panaikinta.</p><p><strong>Po šio pakeitimo atkūrimo kodai bus vienintelis būdas atgauti prieigą prie savo paskyros, jei prarasite savo 2FA įrenginį.</strong></p><p><strong>Pastaba</strong>: Šis pakeitimas taikomas tik naudotojams, naudojantiems <strong>autentifikavimo programėlę</strong>. Jei naudojate 2FA el. pašto parinktį, jūsų procesas lieka toks pat, ir jums nereikia atkūrimo kodų.</p></section><section><h3>Kaip pasiruošti (padarykite tai dabar!)</h3></section><section><p>Nelaukite, kol būsite užblokuoti. Savo atkūrimo kodų sąrašą galite sugeneruoti jau šiandien:</p><ol><li>Eikite į <strong>Nustatymai</strong> -> <strong>Saugumas</strong>.</li><li>Skyriuje <strong>Generuoti atkūrimo kodus</strong> spauskite mygtuką <strong>Generuoti</strong>.</li><li>Jums bus paprašyta įvesti <strong>OTP (vienkartinį slaptažodį)</strong> iš jūsų dabartinio autentifikavimo patvirtinimo įrenginio, kad būtų patvirtinta jūsų tapatybė.</li><li><strong>Šiuos kodus išsaugokite nedelsdami.</strong> Jūsų saugumo sumetimais jie bus rodomi tik vieną kartą. Išspausdinkite juos, užsirašykite arba išsaugokite saugioje slaptažodžių tvarkyklėje.</li></ol><p><strong>Pastaba</strong>: Sukūrus naują kodų sąrašą, senieji kodai automatiškai taps negaliojantys.</p></section><section><h3>Kaip veikia atkūrimas</h3></section><section><p>Jei praradote telefoną arba ištrinote autentifikavimo patvirtinimo programėlę, štai kaip galėsite vėl prisijungti:</p><ol><li><strong>Prisijunkite</strong> - Įveskite savo įprastą el. pašto adresą ir slaptažodį.</li><li><strong>2FA užklausa</strong> - Kai bus paprašyta įvesti kodą, spustelėkite <strong>„Naudoti atkūrimo kodą“</strong>.</li><li><strong>Autentiškumo patvirtinimas</strong> - Įveskite vieną iš nenaudotų atkūrimo kodų.</li><li><strong>Atstatymas</strong> - Kai kodas bus panaudotas, jūsų 2FA bus automatiškai išjungta, kad galėtumėte vėl prisijungti.</li><li><strong>Pakartotinis nustatymas</strong> - Turite nedelsiant nustatyti naują 2FA metodą.</li><li><strong>Nauji kodai</strong> - Jūsų senas atkūrimo kodų sąrašas bus panaikintas, todėl įsitikinkite, kad išsaugojote naują sąrašą, kai jūsų nauja 2FA bus aktyvi.</li></ol></section>",
                "12": "<section><p>Informuojame, kad FMx platformos veikla buvo sustabdyta nuo <strong>2026-04-18 15:04 UTC</strong> iki <strong>2026-04-20 05:00 UTC</strong>.</p></section><section><h3>Techninė priežastis</h3></section><section><p>Incidentas kilo dėl AWS serverio veikimo sutrikimo ir vėlesnio išjungimo. Nors mūsų automatinio mastelio keitimo sistema teisingai nustatė gedimą ir sukūrė naują VM, netinkama konfigūracija automatinio naujo serverio nustatymo metu sutrukdė FMx įrenginiams prisijungti prie FOTA WEB.</p></section><section><h3>Sprendimas</h3></section><section><p>Konfigūracijos klaida buvo nustatyta ir ištaisyta. Nuo <strong>2026-04-20 05:00 UTC</strong> visos paslaugos veikia visu pajėgumu, o įrenginių ryšys atkurtas.</p></section><section><h3>Ateities prevencija</h3></section><section><p>Mes rimtai vertiname šį sutrikimą ir šiuo metu atliekame išsamią įvykio analizę. Esame pasiryžę tobulinti automatizuotus diegimo ir patvirtinimo procesus, kad ateityje būtų aptiktos ir užkirstas kelias panašioms konfigūracijos problemoms.</p></section>",
                "13": "<section><p>Atkreipkite dėmesį, kad atnaujiname savo API galinius taškus įrenginių grupių valdymui, siekdami pagerinti sistemos našumą ir sumažinti veiklos riziką. Nuo <strong>2026 m. birželio 30 d.</strong> parametras <code>company_id</code> bus visiškai pašalintas iš grupės atnaujinimo galinių taškų (<code>PUT</code> ir <code>PATCH</code> <code>/groups/{groupId}</code>).</p></section><section><h3>Kas keičiasi?</h3></section><section><p>Siekiant užtikrinti sklandesnį apdorojimą fone ir patikimesnę naudotojo patirtį, grupės perkėlimas buvo visiškai atskirtas nuo standartinių grupės atnaujinimų:</p><ul><li><strong>Naudotojo sąsajos pakeitimai</strong> - FOTA WEB sąsajoje įrenginių grupės perkėlimas į kitą įmonę nebėra atliekamas redaguojant grupę. Vietoj to, ši funkcija buvo perkelta į specialų, fone apdorojamą mygtuką <strong>„Perkelti“</strong> „Įrenginių grupės“ puslapyje.</li><li><strong>API pakeitimai</strong> - Galimybė keisti įmonę per grupės atnaujinimo galinius taškus yra pasenusi. Ateityje šis parametras bus visiškai pašalintas iš <code>PUT/PATCH /groups/{groupId}</code>.</li></ul></section><section><h3>Ką turėtumėte daryti?</h3></section><section><p>Rekomenduojame atlikti šiuos pakeitimus būsimoms darbo eigoms:</p><ol><li><strong>Naudokite naują galinį tašką grupių perkėlimui</strong> - Jei per API reikia perkelti įrenginių grupę į kitą įmonę, turite pereiti prie naujo specialaus galinio taško: <code>POST /groups/{groupId}/move</code>.</li><li><strong>Peržiūrėkite API integracijos skriptus</strong> - Įsitikinkite, kad jokiuose senesniuose, dar nepateiktuose ar programiniame kode fiksuotuose kūrimo skriptuose iki 2026 m. birželio 30 d. grupių <code>PUT</code> arba <code>PATCH</code> užklausose nebūtų naudojamas parametras <code>company_id</code>.</li></ol></section>"
            },
            "title": {
                "1": "Privalomas 2FA naujiems naudotojas nuo 2025 m. sausio 7 d.",
                "2": "Planiniai sistemos techniniai priežiūros darbai 2025 m. birželio 3 d.",
                "3": "Nauja funkcija: Lengvesnis įrenginių atrakinimas visiems naudotojams",
                "4": "Atraskite naujoves savo prietaisų skydelyje!",
                "5": "Svarbu: Artėjantys API pakeitimai ir trumpa vaidmenų bei teisių apžvalga",
                "6": "Nauja funkcija: patobulinta naudotojų kontrolė su \"Vaidmenys ir leidimai\"",
                "7": "Nauja funkcija: daugiau lankstumo planuojant užduotis pagal datą",
                "8": "Saugumo atnaujinimas: viso naudotojų prieigos gyvavimo ciklo valdymas",
                "9": "Funkcinis atnaujinimas: suvienodintos išmaniųjų įrenginių grupės FT ir FMx platformoms",
                "10": "Būsimi pokyčiai: naujas FOTA WEB el. laiškų siuntėjo adresas",
                "11": "Saugumo atnaujinimas: 2FA apsaugos stiprinimas",
                "12": "Informacija apie incidentą: FOTA WEB ryšio sutrikimas",
                "13": "Būsimi API pakeitimai: \"Company ID\" šalinimas iš įrenginių grupių galinių taškų"
            }
        },
        "published": "Paskelbta",
        "take me there": "Nuvesk mane ten",
        "tasks": {
            "current": "Šiuo metu",
            "status": {
                "completed": "Atliktos",
                "completed_with_errors": "Užbaigtos su klaidomis",
                "failed": "Nepavykusios",
                "no tasks": "Užduočių nėra"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7 dienos",
                "tooltipTitle": "Paskutinės 7 dienos"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30 dienų",
                "tooltipTitle": "Paskutinės 30 dienų"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90 dienų",
                "tooltipTitle": "Paskutinės 90 dienų"
            }
        },
        "title": {
            "activated": "Aktyvuoti įrenginiai",
            "configurations": "Konfigūracijos",
            "device status": "Įrenginių būsena",
            "firmware versions": "Programinės įrangos versijos",
            "imported": "Importuoti įrenginiai",
            "news": "Naujienos",
            "queued tasks": "Užduotys eilėje",
            "refreshed every hour": "atnaujinama kas valandą",
            "resource limits": "Išteklių limitai",
            "task overview": "Užduočių apžvalga",
            "tasks": "Užduotys"
        },
        "tooltips": {
            "activated": "Įrenginių skaičius, kurie pirmą kartą prisijungė prie FOTA WEB per pasirinktą laikotarpį (šiandien, per paskutines 7, 30 ir 90 dienų).",
            "configurations": "Rodo į jūsų įrenginius įkeltų konfigūracijos failų pasiskirstymą. Rodoma iki 100 unikalių failų pavadinimų.",
            "firmware versions": "Rodo programinių įrangų, kurios buvo pateiktos prijungtų įrenginių, pasiskirstymą. Rodoma iki 100 unikalių versijų.",
            "imported": "Įrenginių skaičius, kurie buvo pridėti prie jūsų paskyros per pasirinktą laikotarpį (šiandien, per paskutines 7, 30 ir 90 dienų)."
        }
    },
    "Date picker": {
        "disableFuture": "Klaidinga data",
        "disablePast": "Klaidinga data",
        "invalidDate": "Klaidinga data",
        "maxDate": "Data neteisinga",
        "minDate": "Data neteisinga",
        "shouldDisableDate": "Klaidinga data",
        "shouldDisableMonth": "Klaidinga data",
        "shouldDisableYear": "Klaidinga data"
    },
    "Device export": {
        "properties": {
            "activity_status": "Būsena",
            "bootloader": "Bootloader",
            "company_name": "Įmonė",
            "created_at": "Sukurta",
            "current_configuration": "Konfigūracija",
            "current_firmware": "Programinė įranga",
            "description": "Aprašymas",
            "group_name": "Grupė",
            "gsm_number": "GSM numeris",
            "iccid": "ICCID",
            "imei": "IMEI",
            "imsi": "IMSI",
            "model": "Modelis",
            "model_platform": "Platforma",
            "modem_version": "Modemo versija",
            "oem_file_vehicle_name": "OEM failo transporto priemonė",
            "product_code": "Užsakymo kodas",
            "seen_at": "Jungėsi",
            "serial": "Serijos Nr.",
            "task_queue": "Eilė",
            "updated_at": "Atnaujinta",
            "vin": "VIN"
        },
        "select data": "Pasirinkite duomenis"
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "Pridėti naują įrenginį",
        "add new device description": "Pridėkite vieną arba kelis naujus įrenginius prie pasirinktos įmonės ir grupės. Tik seni įrenginiai, pvz., FM arba FMA, turi būti pridėti pažymint langelį \"Pridėti kaip 'Legacy' įrenginius\".",
        "add new device legacy title": "Pridėti kaip \"Legacy\" įrenginius.",
        "add new device legacy description": "Nustatyti \"Sukurta\" į 2016.01.01, o \"Modelį\" į Legacy.",
        "add new product code": "Pridėti naują užsakymo kodą",
        "add new product code description": "Pridėkite naują įrenginio užsakymo kodą ir susiekite jį su turimu CAN paketu.",
        "all permissions": "Visi leidimai",
        "assign access group": "",
        "assign can package description": "Pasirinkite paketo tipą ir priskirkite jį visiems pasirinktiems įrenginiams.",
        "assign role": "Priskirti vaidmenį",
        "attribute value": "Atributo vertė",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "Pradėti parsisiuntimą",
        "by date": "Pagal datą",
        "by time": "Pagal laiką",
        "can adapter": "CAN priedas",
        "cancel pending tasks": "Atšaukti laukiančias to paties tipo užduotis",
        "cancel tasks": "Atšaukti užduotis",
        "cancel tasks in group": {
            "alert title": "Šis veiksmas gali užtrukti iki kelių minučių.",
            "banner description": "Norėdami pamatyti atnaujintą užduočių būseną, žiūrėkite išsamios informacijos skiltį arba atnaujinkite puslapį.",
            "banner title": "Šis veiksmas gali užtrukti iki kelių minučių, atsižvelgiant į užduočių skaičių.",
            "description": "Paspaudus \"Priimti\", bus atšauktos visos laukiančios ir vykdomos užduotys. Ar tikrai norite tęsti?",
            "title": "Atšaukti visas užduotis šioje grupėje?"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "Perkėlus įrenginius iš pasirinktos kliento/virtualios įmonės į kitą kliento/virtualią įmonę (skirtinga hierarchija), jų istorija ir užduotys ištrinamos automatiškai. Perkeliant įrenginius tos pačios hierarchijos ribose, užduočių ir istorijos ištrynimas yra pasirinktinis.",
        "client email": "Kliento atstovo el. paštas",
        "companies": "Įmonės",
        "company": "Įmonė",
        "company level": {
            "Basic": "Pagrindinis",
            "Internal": "Vidinis",
            "Premium": "Premium",
            "Standard": "Standartinis"
        },
        "company level change description": "Atnaujinkite įmonės lygį pasirinkdami naują lygį ir pateikdami paaiškinimą, kodėl. Sumažinti įmonės lygio neįmanoma. Visos datos nurodytos UTC.",
        "company level manual revert": {
            "confirmation": {
                "description": "Šis veiksmas grąžins įmonės lygį į automatiškai priskirtą \"{{companyLevel}}\" lygį. Ar tikrai norite tęsti?",
                "title": "Grąžinti rankinį lygio keitimą?"
            },
            "description": "Grąžinus įmonės lygis bus pakeistas į automatiškai priskirtą lygį.",
            "title": "Šis įmonės lygis buvo atnaujintas rankiniu būdu iki {{expirationDate}}."
        },
        "company level type": "Įmonės lygio tipas",
        "company name": "Įmonės pavadinimas",
        "company statistics": {
            "child companies": "Antrinių įmonių skaičius",
            "devices": "Įrenginių skaičius",
            "files": "Failų skaičius",
            "groups": "Įrenginių grupių skaičius",
            "tasks": "Užduočių skaičius",
            "users": "Naudotojų skaičius"
        },
        "company type": {
            "All": "",
            "Client": "Klientas",
            "Internal": "Vidinis",
            "Virtual": "Virtualus"
        },
        "configuration": "Konfigūracija",
        "confirmations": {
            "are you sure": "Ar esate tuo tikri?",
            "are you sure you wish to continue": "Ar tikrai norite tęsti?",
            "assign can package confirmation": "Ar tikrai norite priskirti pasirinktą paketą nurodytam skaičiui įrenginių?",
            "cancel task confirmation": {
                "first part": "Ar tikrai norite ištrinti nurodytą skaičių užduočių?",
                "second part": "Jei taip, įveskite paveiktų užduočių skaičių ir spauskite \"Patvirtinti\"."
            },
            "create task confirmation": "Ar tikrai norite sukurti užduotį nurodytam skaičiui įrenginių?",
            "delete resource confirmation": {
                "first part": "Ar tikrai norite ištrinti nurodytą {{resource}} skaičių?",
                "second part": "Jei taip, įveskite paveiktų {{resource}} skaičių ir spauskite \"Naikinti\"."
            },
            "delete resources": {
                "companies": "įmonių",
                "files": "failų",
                "groups": "įrenginių grupių",
                "deviceModels": "modelių",
                "productCodes": "užsakymų kodų",
                "roles": "vaidmenų",
                "users": "naudotojų"
            },
            "description second part": "Jei taip, įveskite paveiktų įrenginių skaičių ir spauskite \"Patvirtinti\".",
            "export device data confirmation": "Ar tikrai norite eksportuoti duomenis nurodytam skaičiui įrenginių?",
            "file": "Įveskite faile esančių eilučių skaičių",
            "filter": {
                "companies": "Įveskite išfiltruotų įmonių skaičių",
                "devices": "Įveskite išfiltruotų įrenginių skaičių",
                "files": "Įveskite išfiltruotų failų skaičių",
                "groups": "Įveskite išfiltruotų įrenginių grupių skaičių",
                "productCodes": "Įveskite išfiltruotų užsakymų kodų skaičių",
                "tasks": "Įveskite išfiltruotų užduočių skaičių",
                "users": "Įveskite išfiltruotų naudotojų skaičių"
            },
            "id_list": {
                "companies": "Įveskite pasirinktų įmonių skaičių",
                "devices": "Įveskite pasirinktų įrenginių skaičių",
                "files": "Įveskite pasirinktų failų skaičių",
                "groups": "Įveskite pasirinktų įrenginių grupių skaičių",
                "productCodes": "Įveskite pasirinktų užsakymų kodų skaičių",
                "tasks": "Įveskite pasirinktų užduočių skaičių",
                "users": "Įveskite pasirinktų naudotojų skaičių"
            },
            "merge companies confirmation": "Jūs ketinate sujungti {{sourceCompany}} ir {{targetCompany}} įmones.",
            "move companies confirmation": "Jūs ketinate perkelti {{sourceCompany}} į {{targetCompany}} įmonę.",
            "move devices confirmation": "Ar tikrai norite perkelti nurodytą skaičių įrenginių į kitą kompaniją?",
            "number of lines": "Eilučių skaičius",
            "selected 20 or more devices": "Jūs pasirinkote 20 ar daugiau įrenginių...",
            "transfer devices confirmation": "Ar tikrai norite perduoti nurodytą skaičių įrenginių į kitą kompaniją?"
        },
        "confirm cannot revert": "Šio veiksmo nebus galima atšaukti.",
        "confirm merge companies": "Ar tikrai norite sujungti šias įmones?",
        "count": "Kiekis",
        "create company": "Sukurti įmonę",
        "create company description": "Sukurti naują įmonę po pasirinkta patronuojančiąja įmone.",
        "create desktop license": "Sukurti desktop licenciją",
        "create desktop license description": "Sukurkite naują desktop licenciją, nurodydami IP, kompiuterinės įrangos raktą ir galiojimo laiką (maks. 2 metai).",
        "create group": "Sukurti grupę",
        "create group description": "Suskirstykite įrenginius į grupes, kad būtų paprasčiau juos valdyti ir priskirti užduotis keliems įrenginiams vienu metu.",
        "create model": "Sukurti modelį",
        "create model description": "Sukurkite naują įrenginio modelį, nurodydami pavadinimą, platformą ir TCT web palaikymą.",
        "create offline license": "Sukurti offline licenciją",
        "create or edit group description": "Programinė įranga ir (arba) konfigūracija gali būti priskirta grupei. Tai atlikus visiems grupėje esantiems įrenginiams bus sukurtos užduotys.",
        "create role": "Sukurti vaidmenį",
        "create role description": "Sukurkite naują vaidmenį suteikiant jam pavadinimą ir aprašymą, pasirenkant įmonę ir nurodant konkrečias teises.",
        "create smart group": "Sukurti Smart Group",
        "create smart group banner message": "Pakeitus failus, bus atšauktos visos ankstesnės to paties tipo užduotys, kurių vykdymas dar nebuvo baigtas.",
        "create smart group description": "Programinė įranga ir (arba) konfigūracija gali būti priskirta kiekvienos platformos grupei. Tai atlikus, visiems grupėje esantiems įrenginiams bus sukurtos užduotys.",
        "create task description first step": "Sukurkite įvairių užduočių - nuo konfigūracijos ar programinės įrangos atnaujinimo iki žurnalų, konfigūracijos ir kt. gavimo iš pasirinktų arba išfiltruotų įrenginių. Be to, užduotis galite suplanuoti pasirinktam laiko periodui.",
        "create task description last step": "Prieš kurdami užduotį įsitikinkite, kad toliau pateikta informacija yra teisinga.",
        "current level": "dabartinis lygis",
        "custom resource limits": {
            "at least one limit must be higher": "Bent viena reikšmė turi būti didesnė už numatytąją Premium lygio reikšmę.",
            "configuration files per device": "Konfigūracijos failai įrenginiui",
            "confirmation modal description": "Ar tikrai norite pakeisti šiuos \"{{companyName}}\" įmonės išteklių limitus?",
            "confirmation modal title": "Keisti įmonės išteklių limitus?",
            "count": {
                "companies count": "Įmonių skaičius: {{number}}",
                "configuration files per device count": "Konfigūracijos failų skaičius įrenginiui: {{number}}",
                "tasks per group count": "Užduočių grupėje skaičius: {{number}}",
                "users count": "Naudotojų skaičius: {{number}}"
            },
            "explanations": {
                "companies": "Bendras dukterinių įmonių, kurias galima sukurti įmonės hierarchijoje, skaičius.",
                "configuration files per device": "Konfigūracijos failų, kuriuos galima saugoti, skaičius. Vienam įrenginiui priskiriamas vienas konfigūracijos failas. Kiekvienam įmonės hierarchijos lygiui garantuojama mažiausiai 100 konfigūracijos failų.",
                "tasks per group": "Užduočių, kurios gali būti vienoje užduočių grupėje, skaičius.",
                "users": "Bendras naudotojų, kuriuos galima sukurti įmonės hierarchijoje, skaičius."
            },
            "main modal description": "Nustatykite kitą išteklių kiekį skirtingiems išteklių tipams, tokiems kaip įmonės, naudotojai, užduočių grupės ar konfigūracijos failai. Priskirti ištekliai bus aktyvūs iki Premium lygio galiojimo pabaigos arba rankinio nustatymo iš naujo.",
            "resources limit type": "Išteklių limito tipas",
            "revert custom resource limits": "Atstatyti pradinius išteklių limitus",
            "revert custom resource limits description": "Atstačius visus limitus, bus nustatytos pradinės išteklių reikšmės, o įmonės lygis bus pakeistas į Premium.",
            "revert custom resource limits description confirmation": "Šis veiksmas atstatys išteklių limitus į automatiškai priskirtus \"Premium\" lygiui limitus. Ar tikrai norite tęsti?",
            "revert custom resource limits title": "Šios įmonės išteklių limitai buvo nustatyti rankiniu būdu.",
            "revert custom resource limits title confirmation": "Atstatyti pradinius išteklių limitus?",
            "tasks per group": "Užduotys vienai grupei"
        },
        "date range": "Datos intervalas",
        "date to": "iki",
        "delete companies": "Naikinti įmones",
        "delete deviceModels": "Naikinti modelius",
        "delete files": "Naikinti failus",
        "delete file warning": "Ištrynus failus bus atšauktos susijusios užduotys ir užduočių grupės.",
        "delete groups": "Naikinti įrenginių grupes",
        "delete productCodes": "Naikinti užsakymų kodus",
        "delete roles": "Naikinti vaidmenis",
        "delete tasks and history": "",
        "delete users": "Naikinti naudotojus",
        "description": "Aprašymas",
        "desktop license delete description": "Ar tikrai norite ištrinti \"{{name}}\" desktop licenciją?",
        "desktop license name": "Desktop licencijos pavadinimas",
        "device identifier": "Įrenginio identifikatorius",
        "device transfer": {
            "main": {
                "description": "Perduokite pasirinktus arba išfiltruotus įrenginius nesusijusiai kompanijai naudodami gaunančios įmonės sugeneruotą prieigos raktą.",
                "title": "Įrenginio perdavimas"
            },
            "receive devices": {
                "copy token": "Nukopijuokite ir perduokite šį sugeneruotą žetoną asmeniui, atsakingam už įrenginių perdavimą iš jo įmonės į jūsų.",
                "description": "Sukurkite įrenginių priėmimo žetoną ir nusiųskite jį perdavimo įmonei.",
                "token info": "Žetonas skirtas vienkartiniam naudojimui ir nustoja galioti po 21 dienos."
            },
            "transfer devices": {
                "confirmation": "Ar tikrai norite perduoti įrenginius į toliau nurodytą įmonę?",
                "device token": "Įrenginio perdavimo žetoną turite gauti iš įmonės, kuriai norite perduoti įrenginius.",
                "transfer from file": "Įkelkite failą su įrenginių sąrašu (IMEI), kuriuos norite perduoti iš savo įmonės į įmonę, kurios žetoną ką tik įvedėte."
            }
        },
        "device transfer token": "Įrenginio perdavimo žetonas",
        "downgrading company level is not possible": "Sumažinti įmonės lygio negalima",
        "download sample file message": "Atsisiųskite <1>CSV šabloną</1>, kad pamatytumėte reikiamo formato pavyzdį.",
        "edit group banner message": "Pakeitus programinę įrangą ir/ar konfigūracijos failus, bus atšauktos visos ankstesnės laukiančios to paties tipo užduotys.",
        "edit group description": "Redaguokite šios įrenginių grupės nustatymus.",
        "edit role description": "Keiskite vaidmens pavadinimą, aprašymą ir teises. Priskirtos įmonės keisti negalima.",
        "edit smart group description": "Programinė įranga ir (arba) konfigūracija gali būti priskirta arba pakeista kiekvienos platformos grupei. Tai atlikus, visiems grupėje esantiems įrenginiams bus sukurtos užduotys.",
        "email": "El. paštas",
        "enter": "Įveskite",
        "enter code": "Įvesti kodą",
        "enter description": "Įvesti aprašymą",
        "enter name": "Įvesti pavadinimą",
        "example": "Pvz.:",
        "expires at": "Galioja iki",
        "explanation": "Paaiškinimas",
        "export device data": "Eksportuoti įrenginių duomenis",
        "export device description": "Eksportuokite pasirinktų arba filtruotų įrenginių duomenis į .csv arba .xlsx formato failą.",
        "export file format": "Eksporto failo formatas",
        "feature": "Funkcija",
        "feature control": "Funkcijos valdymas",
        "field disabled until company selected": "Šis laukelis yra išjungtas, kol nebus pasirinkta įmonė.",
        "firmware": "Programinė įranga",
        "files to download": "Failai atsisiųsti",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "Įkeltas 1-Wire autorizacijos sąrašas bus automatiškai surūšiuotas, kad būtų pagerintas funkcionalumo greitis ir tikslumas.",
                "bluetooth_authorization_list": "Įkeltas Bluetooth autorizacijos sąrašas bus automatiškai surūšiuotas, kad būtų pagerintas funkcionalumo greitis ir tikslumas."
            },
            "endings": {
                "file": "failo",
                "files": "failų"
            },
            "fail": {
                "multiple": "{{failCount}} iš {{totalCount}} {{fileEnding}} nebuvo įkelti dėl klaidos.",
                "single": "{{failCount}} iš {{totalCount}} {{fileEnding}} nebuvo įkeltas dėl klaidos."
            },
            "success": {
                "multiple": "Visi failai buvo sėkmingai pridėti prie pasirinktų įmonių.",
                "single": "Visi failai buvo sėkmingai pridėti prie pasirinktos įmonės."
            }
        },
        "filtered": "Išfiltruota",
        "filtered companies": "Išfiltruotos įmonės",
        "filtered devices": "Išfiltruoti įrenginiai",
        "filtered files": "Išfiltruoti failai",
        "filtered groups": "Išfiltruotos grupės",
        "filtered tasks": "Išfiltruotos užduotys",
        "filtered users": "Išfiltruoti naudotojai",
        "find tool": {
            "device": {
                "error not valid": "IMEI turi būti sudarytas iš 15 simbolių",
                "error subtitle": "Įrenginis nerastas. Pabandykite įvesti kitą IMEI.",
                "error title": "Įrenginys nerastas",
                "link": "Eiti į įrenginį",
                "no permission": "Jūs neturite leidimo peržiūrėti šio įrenginio."
            },
            "user": {
                "error not valid": "Netinkamas el. pašto adreso formatas",
                "error subtitle": "Naudotojas nerastas. Pabandykite įvesti kitą naudotojo el. paštą.",
                "error title": "Naudotojas nerastas",
                "link": "Eiti į naudotoją",
                "no permission": "Jūs neturite leidimo peržiūrėti šio naudotojo."
            }
        },
        "firmware date": "Prog. įrangos data",
        "from form": "Iš formos",
        "from file": "Iš failo",
        "general": "Bendrieji",
        "gsm_number": "GSM numeris",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "IMEI apribojimas",
        "import device data": "Importuoti įrenginio duomenis",
        "import device data description": "Importuokite pasirinktus įrenginių atributų duomenis iš pateikto sąrašo.",
        "import device data info": "Kiekvienam atributui skliausteliuose nurodytas maksimalus simbolių limitas. Jei atributas turi daugiau simbolių nei maksimali riba, jis bus automatiškai sutrumpintas iki maksimalios ribos.",
        "import device data limit": "(daugiausia simbolių {{limit}})",
        "imsi": "IMSI",
        "input text too long": "Tekstas per ilgas. Leidžiama ne daugiau kaip {{maxLength}} simbolių.",
        "invalid hardware key": "Netinkamas kompiuterinės įrangos rakto formatas",
        "invalid imei": "IMEI negalioja",
        "invalid ipv4": "Netinkamas IPv4 formatas",
        "invalid serial": "Neteisingas serijos numeris",
        "invalid value": "Klaidinga reikšmė",
        "inverted selection": "Atvirkštinis pasirinkimas",
        "invite user": "Pakviesti naudotoją",
        "invite user description": "Po išsiuntimo naudotojas turės 30 dienų patvirtinti kvietimą iki jo galiojimo pabaigos.",
        "invite user max roles": "Leidžiami daugiausia 5 vaidmenys. Norėdami tęsti, atžymėkite vieną.",
        "log files": "Žurnalo failai",
        "make": "Automobilio markė",
        "manage permissions": "Valdykite visus paskyros ir svetainės lygio duomenis.",
        "maximum value is": "Maksimali vertė yra {{value}}",
        "merge companies": "Sujungti įmones",
        "merge companies info": "Visi įmonės ištekliai (įrenginiai, grupės, failai, antrinės įmonės, naudotojai su jų vaidmenimis) bus perkelti į nurodytą įmonę. Prieš sujungiant, galite peržiūrėti naudotojų vaidmenis. Šaltinio įmonė bus pašalinta.",
        "merge companies disabled option": {
            "client to internal": "Kliento tipo įmonė negali būti sujungta su vidinio tipo įmone.",
            "internal": "Vidinio tipo įmonė negali būti naudojama sujungimui.",
            "lz code": "Įmonė, turinti kodą, negali būti naudojama sujungimui."
        },
        "minimum value is": "Minimali vertė yra {{value}}",
        "move companies disabled option": {
            "internal": "Vidinio tipo įmonė negali būti perkelta."
        },
        "move device": "Perkelti įrenginį",
        "move device description": "Perkelkite pažymėtus ar išfiltruotus įrenginius į kompanijos hierarchijoje egsiztuojančią kompaniją ir/ar grupę.",
        "move device group": "Perkelti įrenginių grupę",
        "move device group banner": "Perkėlus pasirinktą įrenginių grupę į kitą įmonę, su ja susiję įrenginiai bus automatiškai perkelti.",
        "move device group description": "Perkelkite pasirinktą įrenginių grupę į pasirinktą įmonę.",
        "move devices": "Perkelti įrenginius",
        "name": "Pavadinimas",
        "newest": "Nuo naujausio",
        "no dropdown files": {
            "description": "Norėdami pasirinkti šią parinktį, įkelkite naują $t(Dialog##no dropdown files##file names##{{fileName}}) failą.",
            "description no permission create file": "Norėdami pasirinkti šią parinktį, naujas $t(Dialog##no dropdown files##file names##{{fileName}}) failas turi būti įkeltas, bet jums reikalingas šis leidimas: \"$t(General##File.Create)\".",
            "file names": {
                "1_wire_authorization_list": "1-Wire autorizacijos sąrašo",
                "adas_firmware": "ADAS programinės įrangos",
                "ble_fw": "BLE programinės įrangos",
                "blue_nrg": "BlueNrg programinės įrangos",
                "bluetooth_authorization_list": "Bluetooth autorizacijos sąrašo",
                "can_chip_firmware": "FM CAN lusto programinės įrangos",
                "carrier_advance_firmware": "Carrier Advance programinės įrangos",
                "carrier_advance_settings": "Carrier Advance nuostatų",
                "carrier_apx_firmware": "Carrier APX programinės įrangos",
                "carrier_apx_settings": "Carrier APX nuostatų",
                "certificate": "TLS sertifikato",
                "configuration": "konfigūracijos",
                "dsm_firmware": "DSM programinės įrangos",
                "dtb": "DTB",
                "firmware": "programinės įrangos",
                "fw_bundle": "programinės įrangos paketo",
                "gnssm_download_assistant": "GNSS-M Download Assistant programinės įrangos",
                "gnssm_firmware": "GNSS-M programinės įrangos",
                "main configuration": "pagrindinės konfigūracijos",
                "manual_geofence_list": "Rankiniu būdu sukurto geozonos scenarijų sąrašo",
                "meig_modem_firmware": "MeiG modemo programinės įrangos",
                "netprisma_modem_firmware": "NETPRISMA modemo programinės įrangos",
                "psub": "prenumeratos",
                "quectel_modem_firmware": "Quectel modemo programinės įrangos",
                "simcom_modem_firmware": ""
            },
            "main": "$t(Dialog##no dropdown files##file names##{{fileName}}) failų nėra."
        },
        "none": "Netaikyti",
        "obd oem": "OBD OEM",
        "offline license delete description": "Ar tikrai norite ištrinti \"{{name}}\" offline licenciją?",
        "oldest": "Nuo seniausio",
        "only integers": "Tik sveikieji skaičiai",
        "only numbers": "Tik skaičiai",
        "optional": "neprivaloma",
        "other companies": "Kitos įmonės",
        "parent company": "Patronuojančioji įmonė",
        "permission preset": "Leidimų šablonas",
        "platform compatibility": {
            "banner text": "Kai kurie pasirinkti įrenginių modeliai yra nesuderinami su pasirinktu užduočių tipu. Šis užduočių tipas nebus sukurtas nesuderinamiems įrenginių modeliams.",
            "compatible model devices": "Suderinami modelio įrenginiai",
            "count text": "Užduotis bus sukurta <1>{{compatibleCount}}</1> iš {{totalCount}} įrenginių.",
            "create tasks for incompatible devices": "Kurti užduotis nesuderinamiems įrenginiams.",
            "devices from file": "Įrenginiai iš failo",
            "platform": "{{title}} platforma",
            "task applies": "Užduotis taikoma",
            "task cannot be created": "Negalima sukurti užduoties nesuderinamiems įrenginių modeliams."
        },
        "receiving company": "Ši įmonė gaus jūsų įrenginius",
        "resend user invitation": "Pakartotinai išsiųsti kvietimą naudotojui",
        "retry tasks in group": {
            "alert title": "Šis veiksmas gali užtrukti iki kelių minučių.",
            "banner description": "Norėdami pamatyti atnaujintą užduočių būseną, žiūrėkite išsamios informacijos skiltį arba atnaujinkite puslapį.",
            "description": "Paspaudus \"Priimti\", bus iš naujo paleistos visos nepavykusios užduotys. Ar tikrai norite tęsti?",
            "title": "Iš naujo paleisti visas nepavykusias užduotis šioje grupėje?"
        },
        "revision": "Revizija",
        "revision value error": "Reikšmė turi būti sudaryta iš dviejų skaitmenų (00 - 99).",
        "role name": "Vaidmens pavadinimas",
        "root company": "Motininė įmonė",
        "sales email": "Pardavimų vadybininko el. paštas",
        "scheduled time warning": "Užduotys su suplanuotu laiku nekeičia įrenginio FOTA ryšio laiko konfigūracijos. Užduotys bus vykdomos, jei įrenginys prisijungs prie FOTA per pasirinktą laiko periodą. Įsitikinkite, kad įrenginiai sukonfigūruoti prisijungti prie FOTA Web ne trumpesniu nei pasirinkto laiko lango laikotarpiu.",
        "schedule task": "Suplanuoti užduotį",
        "select": "Pasirinkite",
        "select at least one": {
            "companies": "Pasirinkite bent vieną įmonę",
            "devices": "Pasirinkite bent vieną įrenginį",
            "files": "Pasirinkite bent vieną failą",
            "groups": "Pasirinkite bent vieną grupę",
            "tasks": "Pasirinkite bent vieną užduotį",
            "users": "Pasirinkite bent vieną naudotoją"
        },
        "selected": "Pasirinkta",
        "selected companies": "Pasirinktos įmonės",
        "selected deviceModels": "Pasirinkti modeliai",
        "selected devices": "Pasirinkti įrenginiai",
        "selected files": "Pasirinkti failai",
        "selected groups": "Pasirinktos įrenginių grupės",
        "selected productCodes": "Pasirinkti užsakymų kodai",
        "selected roles": "Pasirinkti vaidmenys",
        "selected tasks": "Pasirinktos užduotys",
        "selected users": "Pasirinkti naudotojai",
        "select company": "Pasirinkti įmonę",
        "select group": "Pasirinkti grupę",
        "select time interval": "Pasirinkti laiko intervalą",
        "selected time window": "Pasirinktas laiko intervalas: nuo {{fromDate}} iki {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "Bluetooth slaptažodis",
            "repeat bluetooth password": "Pakartokite Bluetooth slaptažodį",
            "enter password": "Įveskite slaptažodį",
            "password source": "Slaptažodžio šaltinis",
            "rules": {
                "allowed characters": "Raidės (a–z, A–Z), skaitmenys (0–9), specialieji simboliai ({{specialSymbols}})",
                "characters length": "Nuo 8 iki 32 simbolių",
                "passwords must match": "Slaptažodžiai turi sutapti"
            },
            "SystemGenerated": {
                "description": "Sistema kiekvienam įrenginiui sugeneruos unikalų, saugų slaptažodį"
            },
            "UserEntered": {
                "description": "Įveskite slaptažodį, kurį norite priskirti įrenginiui(-iams)"
            }
        },
        "show files for selected companies only": "Rodyti tik pasirinktų įmonių failus",
        "smart group": {
            "description": "Pasirinkite {{platformName}} platformos įrenginiams skirtus failus.",
            "title": "{{platformName}} platformos failai"
        },
        "sn": "Serijos Nr.",
        "specific": "Pasirenkamieji",
        "time period": "Laikotarpis",
        "time period custom": "Pasirinktinis",
        "tls certificate transfer info": "<strong>FMx platformos</strong> ryšio kanalo saugumas neatitinka TLS saugaus sertifikato perdavimo reikalavimų. Naudokite atsargiai. <strong>FT platformos</strong> įrenginiai yra visiškai suderinami ir palaiko saugų perdavimą.",
        "token has expired": "API žetono galiojimo laikas baigėsi",
        "token is valid": "API žetonas galioja",
        "transfer companies": "Perduoti įmones",
        "transfer companies description": "Pasirinkite, ar norite perkelti ar sujungti dvi įmones. Kai kurios parinktys yra negrįžtamos.",
        "transfer devices": "Perduoti įrenginius",
        "tri source": {
            "selected tab description": {
                "create task": "Užduotis bus sukurta pasirinktiems įrenginiams.",
                "general": "Pasirinktas veiksmas bus atliktas pasirinktiems įrenginiams."
            },
            "filtered tab description": {
                "create task": "Užduotis bus sukurta išfiltruotiems įrenginiams naudojant vieną ar daugiau filtrų.",
                "general": "Pasirinktas veiksmas bus atliktas išfiltruotiems įrenginiams naudojant vieną ar daugiau filtrų."
            },
            "from file tab description": {
                "create task": "Užduotis bus sukurta įrenginiams, kurie buvo nurodyti įkeltame faile.",
                "general": "Pasirinktas veiksmas bus atliktas įrenginiams, kurie buvo nurodyti įkeltame faile."
            }
        },
        "unlocker": {
            "generate unlock key": "Sugeneruoti atrakinimo raktą",
            "generate unlock key description": "Įveskite įrenginio \"Užrakinimo kodą\" gautą TCT. Spauskite mygtuką \"Generuoti\", kad sugeneruotumėte atrakinimo raktą, ir panaudokite jį TCT, kad atrakintumėte įrenginį.",
            "invalid lock code": "Neteisingas įrenginio užrakinimo kodas.",
            "limit reached": "Pasiektas maksimalus atrakinimo raktų limitas.",
            "lock code": "Užrakinimo kodas",
            "select device platform": "Pasirinkite įrenginio platformą",
            "select device platform description": "Pasirinkite tinkamą įrenginio platformą. Telematikos įrenginiai skirstomi į tris platformų kartas: <1>FT</1> (FTx, ATx), <2>FMx</2> (įvairūs FM, FMT, TAT, MSP, TFT, TST, GH ir TMT modeliai) ir <3>Legacy</3> (senesni FM, FMA ir GH modeliai).",
            "unlock key": "Atrakinimo raktas",
            "unlock key success message": "Atrakinimo raktas sėkmingai sugeneruotas."
        },
        "upload file": "Įkelti failą",
        "upload file description": "Įkelkite iki {{count}} failų vienu metu naudodami nuvilkimo laukelį arba juos pasirinkdami.",
        "upload firmware bundle container info": "Prašome įsitikinti, kad jūsų įrenginiuose veikia programinė įranga <strong>3.7.0-rc.22</strong> ar naujesnė versija. Ši užduotis nėra suderinama su ankstesnėmis versijomis ir baigsis nesėkme. Daugiau informacijos rasite mūsų <a>wiki puslapyje.</a>",
        "upload firmware downgrade protection info": "04.00.00 ir naujesnės programinės įrangos versijos turi senesnės versijos įrašymo apsaugą. Norėdami gauti daugiau informacijos apie programinės įrangos pakeitimus, peržiūrėkite mūsų dokumentaciją <1>Teltonika GPS Wiki</1>. Paspausdami mygtuką \"Toliau\" patvirtinate, kad sutinkate su aukščiau pateikta informacija ir ją suprantate.",
        "upload firmware unsupported info": "Atnaujiminas į šią versiją nepalaikomas. Susisiekite su Teltonikos techninės pagalbos skyriumi arba Teltonikos pardavimų vadybininku.",
        "use at least one filter": "Panaudokite bent vieną filtrą",
        "user": "Naudotojas",
        "valid until": "Galioja iki",
        "valid until date disable description": "Šį laukelį galima pakeisti tik tada, kai laikotarpio laukelio reikšmė yra \"Pasirinktinis\"",
        "vehicle model": "Automobilio modelis"
    },
    "Dropzone": {
        "add file": "Pridėti failą",
        "add files": "Pridėti failus",
        "drop file to upload": "Nuvilkite failą, kurį norite įkelti",
        "drop files to upload": "Nuvilkite failus, kuriuos norite įkelti",
        "error uploading the file": "Įkeliant failą įvyko klaida",
        "file invalid type": "Pasirinktas netinkamas failo tipas.",
        "file successfully uploaded": "Failas sėkmingai įkeltas",
        "file syntax": "Failo sintaksė:",
        "invalid format or size": "Neteisingas formatas arba failo dydis viršija {{size}}.",
        "max file size": "Maksimalus failo dydis {{size}}",
        "maximum file limit reached": "Pasiektas maksimalus failų limitas.",
        "only one file can be attached": "Galima pridėti tik vieną failą.",
        "or drop file to upload": "Arba nuvilkite failą, kad įkeltumėte",
        "or drop files to upload": "Arba nuvilkite failus, kad įkeltumėte",
        "rows detected": "Sėkmingai aptiktos faile esančios eilutės",
        "select file": "Pasirinkti failą",
        "select files": "Pasirinkti failus",
        "select file type": "Pirmiausia pasirinkite failo tipą.",
        "supported formats": "Palaikomi formatai",
        "too long file name": "Failo pavadinimas per ilgas. Leidžiami ne daugiau kaip {{maxLength}} simboliai.",
        "too many files description": "Likusius failus galima įkelti įkėlus pasirinktus failus.",
        "too many files title": "Vienu metu galite pridėti ne daugiau kaip {{maxFiles}}."
    },
    "Error": {
        "error": "Klaida",
        "message wait": "Palaukite, kol pašalinsime šiuos nesklandumus.",
        "title": "Kažkas įvyko ne taip, kaip tikėjosi sistema!"
    },
    "Feature highlight": {
        "got it": "Supratau",
        "new feature": "Nauja funkcija!",
        "scenarios description": "Dabar savo įrenginyje galite nustatyti vieną iš šių scenarijų: greičio viršijimas, avarijos aptikimas arba vilkimo aptikimas."
    },
    "Filter": {
        "access group": "",
        "activity_status": "Būsena",
        "all permissions": "Visi leidimai",
        "batch_id": "Paketo ID",
        "company_id": "Įmonė",
        "company selector": "Įmonių pasirinkimas",
        "configuration change origin": "",
        "configuration_file_id": "FMx konfigūracija",
        "configuration type": "",
        "created_by": "Sukūrė",
        "current_configuration": "Konfigūracija",
        "current_firmware": "Programinė įranga",
        "device_imei": "Įrenginio IMEI",
        "file type": "Failo tipas",
        "filtered by": "Išfiltruota pagal",
        "filters used": "Naudoti filtrai",
        "firmware_file_id": "FMx programinė įranga",
        "ft_bluetooth_auth_list_file_id": "FT Bluetooth autorizacijos sąrašas",
        "ft_configuration_file_id": "FT pagrindinė konfigūracija",
        "ft_firmware_file_id": "FT programinė įranga",
        "ft_one_wire_auth_list_file_id": "FT 1-Wire autorizacijos sąrašas",
        "group_id": "Grupė",
        "id": "ID",
        "Invalid company": "Neteisinga kompanija",
        "model": "Modelis",
        "model_platform": "Platforma",
        "Multiple companies": "Kelios kompanijos",
        "parent company": "Patronuojančioji įmonė",
        "permission": "Leidimas",
        "permission status": "Būsena",
        "role": "Vaidmuo",
        "spec_id": "Spec. ID",
        "status_id": "Būsena",
        "supported_task_type": "Užduoties tipas",
        "table filters": "Lentelės filtrai",
        "task type": "Užduočių tipas",
        "task_queue": "Užduočių eilė",
        "type": "Tipas",
        "user status": "Būsena"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "ADAS programinės įrangos failo dydis negali būti nulis.",
        "ADAS firmware is invalid.": "Netinkama ADAS programinė įranga.",
        "All notifications were deleted.": "Visi pranešimai panaikinti.",
        "All notifications were marked as read.": "Visi pranešimai pažymėti kaip perskaityti.",
        "At least one user role must be provided.": "Turi būti nurodytas bent vienas naudotojo vaidmuo.",
        "Attributes length is invalid": "Atributų ilgis yra neleistinas.",
        "Banner was updated.": "Atnaujintas informacinis skydelis.",
        "Batch was discarded": "Užduočių grupė buvo atmesta.",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "Sukurta masinio atributo atnaujinimo užduotis. Įrenginių atributai netrukus bus atnaujinti.",
        "Bulk create job was created. Devices will be created shortly.": "Veiksmas pradedamas vykdyti. Įrenginiai netrukus bus pridėti.",
        "Bulk create job was created. Tasks will be created shortly.": "Veiksmas pradedamas vykdyti. Užduotys netrukus bus sukurtos.",
        "Bulk delete job was created. Companies will be removed shortly.": "Veiksmas pradedamas vykdyti. Įmonės netrukus bus pašalintos.",
        "Bulk delete job was created. Devices will be removed shortly.": "Veiksmas pradedamas vykdyti. Įrenginiai netrukus bus pašalinti.",
        "Bulk delete job was created. Files will be removed shortly.": "Veiksmas pradedamas vykdyti. Failai netrukus bus pašalinti.",
        "Bulk delete job was created. Groups will be removed shortly.": "Veiksmas pradedamas vykdyti. Grupės netrukus bus pašalintos.",
        "Bulk delete job was created. Product codes will be removed shortly.": "Veiksmas pradedamas vykdyti. Užsakymų kodai netrukus bus pašalinti.",
        "Bulk delete job was created. Users will be removed shortly.": "Veiksmas pradedamas vykdyti. Naudotojai netrukus bus pašalinti.",
        "Bulk task create job was created. Tasks will be created shortly.": "Veiksmas pradedamas vykdyti. Užduotys netrukus bus sukurtos.",
        "Bulk update job was created. Devices will be updated shortly.": "Veiksmas pradedamas vykdyti. Įrenginiai netrukus bus atnaujinti.",
        "Bulk update job was created. Tasks will be updated shortly.": "Veiksmas pradedamas vykdyti. Užduotys netrukus bus atnaujintos.",
        "Can adapter was added.": "CAN priedas pridėtas.",
        "Can adapter was deleted.": "CAN priedas panaikintas.",
        "Can adapter was updated.": "CAN priedas atnaujintas.",
        "Can chip firmware file size can't be zero": "Can lusto prog. įrangos failo dydis negali būti lygus nuliui.",
        "Can chip firmware is invalid.": "Netinkama Can lusto programinė įranga",
        "Cannot delete company. Company is not empty.": "Įmonės panaikinti negalima. Įmonė nėra tuščia.",
        "Cannot delete file. It is used by pending or running tasks.": "Failo ištrinti negalima. Jis naudojamas laukiančioms arba vykdomoms užduotims.",
        "Cannot delete file. It is used by running tasks.": "Failo ištrinti negalima. Jis naudojamas vykdomoms užduotims.",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "Negalima ištrinti įrenginiams priskirto užsakymo kodo.",
        "check your email for details": "",
        "Companies count limit exceeded.": "Įmonių skaičiaus limitas viršytas.",
        "Companies in the request must belong to the selected root.": "Užklausoje nurodytos įmonės turi priklausyti pasirinktai motininei įmonei.",
        "Company merge job was created. It will be merged shortly.": "Veiksmas pradedamas vykdyti. Įmonės netrukus bus sujungtos.",
        "Company name already exist.": "Įmonė su tokiu pavadinimu jau egzistuoja.",
        "Company level change is not allowed.": "Įmonės lygio keitimas neleidžiamas.",
        "Company level successfully changed": "Įmonės lygis sėkmingai pakeistas.",
        "company level successfully reverted": "Įmonės lygis sėkmingai grąžintas į automatiškai priskirtą lygį.",
        "Company not allowed to be merged": "Įmonių sujungimas negalimas.",
        "company resource limits changed": "Įmonės išteklių limitai sėkmingai pakeisti.",
        "Company was created.": "Įmonė sukurta.",
        "Company was deleted.": "Įmonė panaikinta.",
        "Company was updated.": "Įmonė atnaujinta.",
        "compatibilities added": "Sinchronizavimo metu pridėti nauji suderinamumai: {{count}}.",
        "compatibilities synchronized": "Trūkstami suderinamumai sėkmingai sinchronizuoti.",
        "Configuration cannot have FOTA functionality disabled": "Konfigūracijoje negali būti išjungtas FOTA funkcionalumas.",
        "Configuration file cannot contain duplicate parameters": "Konfigūracijos faile negali būti pasikartojančių parametrų.",
        "Configuration file size can't be zero": "Konfigūracijos failo dydis negali būti lygus nuliui.",
        "Configuration files count limit exceeded.": "Konfigūracijos failų skaičiaus limitas viršytas.",
        "Configuration version must be defined": "Turi būti nustatyta konfigūracijos versija.",
        "custom resource limits successfully reverted": "Pasirinktiniai išteklių limitai sėkmingai atstatyti į pradinius.",
        "Custom roles feature is not enabled.": "Sukurtais vaidmenimis gali naudotis tik premium įmonės lygių naudotojai. Anksčiau sukurti vaidmenys gali būti trinami.",
        "desktop license added": "Desktop licencija \"{{name}}\" sėkmingai pridėta.",
        "Devices already are in target company": "Įrenginiai jau yra tikslinėje įmonėje.",
        "Device already exists.": "Įrenginys jau egzistuoja.",
        "Device bulk attribute update file cannot be empty": "Įrenginio masinio atributo naujinimo failas negali būti tuščias.",
        "Device bulk attribute update file should be .csv": "Įrenginio masinio atributo naujinimo failas turi būti .csv.",
        "Device export limit reached. You can not export more than 100000 devices": "Pasiektas įrenginių eksportavimo limitas. Negalima eksportuoti daugiau nei 100 000 įrenginių.",
        "Device import limit reached. You can not import more than 100 devices": "Pasiektas įrenginių importavimo limitas. Negalima importuoti daugiau negu 100 įrenginių.",
        "Device model and task type compatibility was updated.": "Įrenginio modelio ir užduoties tipo suderinamumas atnaujintas.",
        "Device model was created.": "Įrenginio modelis sukurtas.",
        "Device model was deleted.": "Įrenginio modelis panaikintas.",
        "Device model was updated.": "Įrenginio modelis atnaujintas.",
        "Device not found": "Įrenginys nerastas.",
        "Device Transfer job was created. Devices will be transfered shortly.": "Buvo sukurta įrenginio perdavimo užduotis. Įrenginiai netrukus bus perkelti.",
        "Device was added.": "Įrenginys pridėtas.",
        "Device was deleted.": "Įrenginys panaikintas.",
        "Device was updated.": "Įrenginys atnaujintas.",
        "Email or password is incorrect.": "Įvestas el. pašto adresas arba slaptažodis yra neteisingas.",
        "Failed to create Product code": "Nepavyko sukurti užsakymo kodo.",
        "Failed to delete Product code": "Nepavyko ištrinti užsakymo kodo.",
        "Failed to import devices.": "Nepavyko importuoti įrenginių.",
        "Failed to Read Product code": "Nepavyko perskaityti užsakymo kodo.",
        "Failed to retry failed tasks": "Nepavyko iš naujo paleisti nepavykusių užduočių.",
        "Failed to update Product code": "Nepavyko atnaujinti užsakymo kodo.",
        "Failed to update task for retry": "Nepavyko iš naujo paleisti užduoties.",
        "Field is not valid": "Netinkamas laukelis.",
        "File description is too long. Max 255 characters allowed.": "Failo aprašas per ilgas. Leidžiami ne daugiau kaip 255 simboliai.",
        "File exceeds entries limit of 10000.": "Failas viršija 10 000 įrašų limitą.",
        "File must not contain duplicated IMEIs": "Faile negali būti pasikartojančių IMEI.",
        "File must not contain IMEIs that already exist in database.": "Faile negali būti IMEI, kurie jau yra duomenų bazėje.",
        "File must not contain invalid IMEIs": "Faile negali būti neteisingų IMEI.",
        "File name is too long. Max 255 characters allowed.": "Failo pavadinimas per ilgas. Leidžiami ne daugiau kaip 255 simboliai.",
        "File name should not contain illegal characters or symbols": "Failo pavadinime negali būti jokių specialiųjų simbolių.",
        "File not found": "Failas nerastas.",
        "File was deleted.": "Failas panaikintas.",
        "File was successfully uploaded.": "Failas sėkmingai įkeltas.",
        "File was updated.": "Failas atnaujintas.",
        "File was uploaded. Devices will be imported shortly.": "Failas įkeltas. Įrenginiai netrukus bus importuoti.",
        "File will be created shortly. Check files in a second.": "Failas netrukus bus sukurtas. Patikrinkite failų puslapį.",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "Programinės įrangos failo dydis negali būti nulis.",
        "First device in file not found.": "Pirmasis įrenginys faile nerastas.",
        "Forbidden": "Uždrausta.",
        "Group name already exist.": "Grupė su tokiu pavadinimu jau egzistuoja.",
        "Group was added.": "\"'{{group}}'\" sėkmingai pridėta.",
        "Group was created.": "Grupė sukurta.",
        "Group was deleted.": "Grupė panaikinta.",
        "Group was updated.": "Grupė atnaujinta.",
        "Invalid device bulk update attribute": "Netinkamas įrenginio masinio atnaujinimo atributas.",
        "Invalid email address.": "Netinkamas el. pašto adresas.",
        "Invalid file contents": "Neteisingas failo turinys.",
        "Invalid file name": "Netinkamas failo pavadinimas.",
        "Invalid invitation token.": "Negaliojanti registravimosi nuoroda.",
        "Invalid token": "Negaliojantis žetonas.",
        "Invalid token length": "Neteisingas žetono ilgis.",
        "Internal Server Error": "Vidinė serverio klaida.",
        "Internal users must sign in using Microsoft Entra ID.": "Vidiniai naudotojai turi prisijungti naudodami Microsoft Entra ID.",
        "License was deleted.": "Licencija buvo ištrinta.",
        "License was updated.": "Licencija buvo atnaujinta.",
        "Maximum companies hierarchy depth exceeded": "Viršytas maksimalus įmonių hierarchijos gylis",
        "Maximum device group size exceeded.": "Viršytas maksimalus įrenginių grupės dydis.",
        "Method Not Allowed": "Metodas neleidžiamas.",
        "Network Error": "Tinklo klaida.",
        "No changes made": "Pakeitimų neatlikta.",
        "No resources found.": "Išteklių nerasta.",
        "not allowed to affect batch": {
            "description": "Įsitikinkite, kad kontroliuojate šią užduočių grupę sukūrusio naudotojo įmonę.",
            "title": {
                "approve": "Neturite leidimo patvirtinti šios užduočių grupės.",
                "discard": "Neturite leidimo atmesti šios užduočių grupės."
            }
        },
        "Not Found": "Nerasta.",
        "Notification was deleted.": "Pranešimas panaikintas.",
        "notify when done title": "Tai gali šiek tiek užtrukti. Paspauskite žemiau esantį mygtuką, kad uždarytumėte šį ekraną ir gautumėte pranešimą, kai veiksmas bus baigtas.",
        "Obd record was created.": "OBD įrašas sukurtas.",
        "Obd record was updated.": "OBD įrašas atnaujintas.",
        "offline license added": "Desktop licencija \"{{name}}\" sėkmingai pridėta.",
        "Offline license was deleted.": "Offline licencija buvo ištrinta.",
        "Only id_list source is supported.": "Palaikomas tik id_list šaltinis.",
        "Only users with Teltonika email can be invited into internal companies.": "Į vidinio tipo įmones gali būti kviečiami tik naudotojai, turintys Teltonikos el. paštą.",
        "Only users with Teltonika email can be moved into internal companies.": "Į vidinio tipo įmones galima perkelti tik Teltonikos el. pašto naudotojus.",
        "Parent company cannot be a descendant of the updated company.": "Įmonės lygis sėkmingai pakeistas.",
        "Password reset link was sent to Your email.": "Slaptažodžio atkūrimo nuoroda išsiųsta į Jūsų el. paštą.",
        "Password reset token is invalid, expired or related user no longer exists.": "Slaptažodžio atkūrimo nuoroda nebegalioja. Ji paseno arba naudotojo nebėra.",
        "Password was changed.": "Slaptažodis pakeistas.",
        "product code added": "Užsakymo kodas \"{{code}}\" sėkmingai pridėtas.",
        "Product code is too long. Max 200 characters allowed.": "Užsakymo kodas per ilgas. Leidžiama ne daugiau kaip 200 simbolių.",
        "ProductCode already exists.": "Užsakymo kodas jau egzistuoja.",
        "ProductCode not found": "Užsakymo kodas nerastas.",
        "Product code was deleted.": "Užsakymo kodas ištrintas.",
        "Product code was updated.": "Užsakymo kodas atnaujintas.",
        "Retry failed tasks job was created": "Nepavykusių užduočių bandymo iš naujo užduotis buvo sukurta.",
        "Role cannot be set for an internal user.": "Vaidmuo negali būti priskirtas vidiniam naudotojui.",
        "Role was created.": "Vaidmuo sukurtas.",
        "Role was deleted.": "Vaidmuo ištrintas.",
        "Role was updated.": "Vaidmuo atnaujintas.",
        "selected company changed": "Pasirinkta įmonė pakeista.",
        "Selected firmware bundle is not supported by the device.": "Įrenginys nepalaiko pasirinkto programinės įrangos paketo.",
        "Server Error": "Serverio klaida.",
        "SMS was sent.": "SMS žinutė išsiųsta.",
        "Something went wrong while saving a new password.": "Išsaugant naują slaptažodį įvyko klaida.",
        "Successfully logged out.": "Sėkmingai atsijungta.",
        "System Admin user level is required in order to perform this action.": "Šį veiksmą gali atlikti tik sistemos administratoriai.",
        "Target company cannot be a descendant of source company.": "Tikslinė įmonė negali būti šaltinio įmonės dukterinė įmonė.",
        "Task create limit exceeded.": "Negalima sukurti užduočių grupės daugiau nei 100 000 užduočių.",
        "Task type is not retriable": "Užduoties tipo negalima iš naujo bandyti",
        "Task was added.": "Užduotis pridėta.",
        "task was created": "Užduotis (\"{{taskType}}\") sukurta įrenginiui {{imei}}. Užduotį galite rasti puslapio \"Įrenginiai\" išsamios informacijos skiltyje \"Užduotys\".",
        "Task was updated.": "Užduotis atnaujinta.",
        "Tasks were approved": "Užduotys patvirtintos.",
        "The given data was invalid.": "Pateikti duomenys neteisingi.",
        "time zone changed": "Laiko juosta pakeista.",
        "Token cannot be null or empty": "Žetono reikšmė negali būti lygi null arba būti tuščia.",
        "token created": "API žetonas sėkmingai sukurtas.",
        "Token has expired": "Žetonas nebegalioja.",
        "Token's and token's owner companies do not match": "Žetono ir žetono savininko įmonės nesutampa.",
        "Token was deleted.": "API žetonas panaikintas.",
        "Too many resources in the request": "Per daug išteklių užklausoje",
        "Too Many Requests": "Per daug užklausų.",
        "Transfer token created": "Perdavimo prieigos raktas sukurtas.",
        "tutorial completed": "Mokomasis vadovas sėkmingai baigtas",
        "Two factor authentication is already activated for the user.": "Dviejų dalių autentifikavimas naudotojui jau aktyvintas.",
        "Two factor authentication successfully disabled.": "Dviejų dalių autentifikavimas sėkmingai išjungtas.",
        "Unable to send SMS. This device does not have a GSM number assigned.": "Išsiųsti SMS nepavyko. Įrenginys neturi priskirto GSM numerio.",
        "Unable to validate Your request.": "Nepavyko patvirtinti Jūsų užklausos.",
        "Unauthenticated.": "Naudotojas neprisijungęs.",
        "Unauthorized": "Naudotojui nesuteiktos teisės.",
        "User access level is not valid": "Naudotojo prieigos lygis nėra leistinas",
        "User invitation was revoked": "Naudotojo kvietimas atšauktas.",
        "User invitation was re-sent": "Kvietimas išsiųstas pakartotinai.",
        "User is already in the system.": "Toks naudotojas jau yra.",
        "User was created.": "Naudotojas sukurtas.",
        "User was deleted.": "Naudotojas panaikintas.",
        "User was invited.": "Naudotojo kvietimas sėkmingai išsiųstas.",
        "User was updated": "Naudotojas atnaujintas.",
        "Users count limit exceeded.": "Naudotojų skaičiaus limitas viršytas.",
        "Your password has been changed.": "Jūsų slaptažodis pakeistas."
    },
    "General": {
        "0": "Naudotojas",
        "5": "IoT sprendimų inžinieriai",
        "10": "Administratorius",
        "15": "Administratorius-vadovas",
        "19": "Vidinė integracija",
        "20": "Sisteminis naudotojas",
        "99": "Super naudotojas",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "Įmonės kūrimas",
        "Company.Delete": "Įmonės šalinimas",
        "Company.Merge": "Įmonių sujungimas",
        "Company.Update": "Įmonės atnaujinimas",
        "Device.Export": "Įrenginio eksportavimas",
        "Device.Read": "Įrenginio skaitymas",
        "Device.SecretsRead": "Įrenginio slaptažodžiai",
        "Device.Transfer": "Įrenginio perdavimas",
        "Device.Unlock": "Įrenginio atrakinimas",
        "Device.Update": "Įrenginio atnaujinimas",
        "DeviceGroup.Create": "Įrenginių grupės kūrimas",
        "DeviceGroup.Delete": "Įrenginių grupės šalinimas",
        "DeviceGroup.Read": "Įrenginių grupės skaitymas",
        "DeviceGroup.Update": "Įrenginių grupės atnaujinimas",
        "File.Create": "Failo kūrimas",
        "File.Delete": "Failo šalinimas",
        "File.Download": "Failo atsisiuntimas",
        "File.Read": "Failo skaitymas",
        "File.TctWebAccess": "TCT web",
        "File.Update": "Failo atnaujinimas",
        "Role.Create": "Vaidmens kūrimas",
        "Role.Delete": "Vaidmens šalinimas",
        "Role.Read": "Vaidmens skaitymas",
        "Role.Update": "Vaidmens atnaujinimas",
        "Task.Create": "Užduoties kūrimas",
        "Task.Read": "Užduoties skaitymas",
        "Task.Retry": "Užduoties kartojimas",
        "Task.Update": "Užduoties atnaujinimas",
        "TaskGroup.Read": "Užduočių grupės skaitymas",
        "TctIntegration.Access": "TCT integracija",
        "Token.Create": "Prieigos rakto kūrimas",
        "Token.Delete": "Prieigos rakto šalinimas",
        "Token.Read": "Prieigos rakto skaitymas",
        "User.Create": "Naudotojo sukūrimas",
        "User.Delete": "Naudotojo šalinimas",
        "User.Read": "Naudotojo skaitymas",
        "User.Update": "Naudotojo atnaujinimas",
        "--- END-OF-PERMISSIONS ---": "",
        "1-wire authorization list": "1-Wire autorizacijos sąrašas",
        "1_wire_authorization_list": "1-Wire autorizacijos sąrašas",
        "Active": "Aktyvus",
        "adas_firmware": "ADAS programinė įranga",
        "apx_firmware": "APX programinė įranga",
        "assign can package": "Priskirti CAN paketą",
        "assigned package": "Priskirtas paketas",
        "automatic": "Automatinis",
        "banner management": "Informacinio skydelio valdymas",
        "batches": "Užduočių grupės",
        "black_box": "Black box",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLE programinė įranga",
        "blue_nrg": "BlueNRG programinė įranga",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "Bluetooth autorizacijos sąrašas",
        "bluetooth_authorization_list": "Bluetooth autorizacijos sąrašas",
        "bluetooth password": "Bluetooth slaptažodis",
        "boolean filtered value name": {
            "task_support": {
                "false": "Nesuderinama",
                "true": "Suderinama"
            },
            "web_editor_support": {
                "false": "TCT web nepalaikomas",
                "true": "TCT web palaikomas"
            }
        },
        "can": "CAN",
        "can adapter name": "CAN priedo pavadinimas",
        "can bootstring": "Bootstring numeris",
        "can configuration": "CAN konfigūracija",
        "can_debug_log": "CAN derinimo žurnalas",
        "can oem file package": "CAN OEM failo paketas",
        "can oem file vehicle": "CAN OEM failo transporto priemonė",
        "can package": "CAN paketas",
        "can program number": "CAN programos numeris",
        "can revision": "CAN revizija",
        "can software date": "CAN programinės įrangos data",
        "can type": "CAN tipas",
        "Cancelled": "Nutraukta",
        "cancel task": "Atšaukti užduotį",
        "can_chip_firmware": "FM CAN lusto programinė įranga",
        "carrier_advance_firmware": "Carrier Advance programinė įranga",
        "carrier_advance_settings": "Carrier Advance nuostatos",
        "carrier_apx_firmware": "Carrier APX programinė įranga",
        "carrier_apx_settings": "Carrier APX nuostatos",
        "carrier_extractions": "Carrier ištraukos",
        "carrier_logger_files": "Carrier Temperature Logger failai",
        "certificate": "Sertifikatas",
        "click for more details": "Spauskite norėdami gauti daugiau informacijos",
        "client ip": "Kliento IP",
        "clone model": "Klonuoti įrenginio modelį",
        "collapse menu": "Suskleisti meniu",
        "companies": "Įmonės",
        "company": "Įmonė",
        "company level": "Įmonės lygis",
        "company type": "Įmonės tipas",
        "company name": "Įmonės pavadinimas",
        "Completed": "Baigta",
        "Completed with errors": "Baigta su klaidomis",
        "configuration": "Konfigūracija",
        "configuration_36": "Konfigūracija (FM36)",
        "configuration_64": "Konfigūracija (FMB64)",
        "crash_dump": "Strigčių išklotinės žurnalas",
        "created at": "Sukurta",
        "created by": "Sukūrė",
        "custom": "Pasirinktinis",
        "custom resource limits": "Pasirinktiniai išteklių limitai",
        "dashboard": "Prietaisų skydelis",
        "delete desktop license": "Ištrinti desktop licenciją",
        "delete offline license": "Ištrinti offline licenciją",
        "desktopLicenses": "Desktop licencijos",
        "device_export_file_csv": "Eksportuoti įrenginiai (.csv)",
        "device_export_file_xlsx": "Eksportuoti įrenginiai (.xlsx)",
        "deviceModels": "Modeliai",
        "deviceModelTaskCompatibilities": "Suderinamumai",
        "device_transfer_report": "Įrenginio perdavimo ataskaita",
        "device group": "Grupė",
        "DeviceImportFile": "Gaminių importavimo failas",
        "devices": "Įrenginiai",
        "download file": "Atsisiųsti failą",
        "download offline license": "Atsisiųsti offline licenciją",
        "dsm_firmware": "DSM programinė įranga",
        "dtb": "DTB",
        "edit compatibility": "Redaguoti įrenginio suderinamumą",
        "edit model": "Redaguoti įrenginio modelį",
        "edit company": "Redaguoti įmonę",
        "edit desktop license": "Redaguoti desktop licenciją",
        "edit device": "Redaguoti įrenginį",
        "edit file": "Redaguoti failą",
        "edit group": "Redaguoti grupę",
        "edit in tct web": "Redaguoti per TCT web",
        "edit in tct web disabled": "Redagavimas per TCT web skirtas tik Premium įmonės lygio naudotojams.",
        "edit product code": "Redaguoti užsakymo kodą",
        "edit role": "Redaguoti vaidmenį",
        "edit smart group": "Redaguoti išmaniąją grupę",
        "edit user": "Redaguoti naudotoją",
        "Empty": "Tuščia",
        "enter here": "Įveskite čia",
        "exception_info": "Gedimo informacija",
        "Executing": "Vykdoma",
        "expand menu": "Išskleisti meniu",
        "Expired": "Nebegalioja",
        "Factory": "",
        "Failed": "Nepavyko",
        "file": "Failas",
        "file data": "Failo duomenys",
        "files": "Failai",
        "file deleted": "Failas panaikintas",
        "firmware": "Programinė įranga",
        "firmware_36": "Programinė įranga (FM36)",
        "firmware_64": "Programinė įranga (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "Programinės įrangos paketas",
        "fw_bundle_ble": "Paketas - BLE programinė įranga",
        "fw_bundle_ble_dtb": "Paketas - BLE DTB programinė įranga",
        "fw_bundle_can": "Paketas - CAN programinė įranga",
        "fw_bundle_can_dtb": "Paketas - CAN DTB programinė įranga",
        "fw_bundle_dtb": "Paketas - pagrindinis DTB",
        "fw_bundle_mainfw": "Paketas - pagrindinė programinė įranga",
        "generic": "Bendrasis failas",
        "global_configuration": "Vieša konfigūracija",
        "global_firmware": "Vieša prog. įranga",
        "gnssm_download_assistant": "GNSS-M Download Assistant prog. įranga",
        "gnssm_firmware": "GNSS-M prog. įranga",
        "group": "Grupė",
        "groups": "Įrenginių grupės",
        "hardware key": "Kompiuterinės įrangos raktas",
        "id": "ID",
        "id_collection_file": "ID rinkinys",
        "imei restriction": "IMEI apribojimas",
        "Inactive": "Neaktyvus",
        "Invalid": "Netinkamas",
        "invalid model": "Netinkamas modelis",
        "invalid model_name": "Netinkamas modelis",
        "InvitationExpired": "Kvietimas nebegalioja",
        "InvitationPending": "Kvietimas laukia patvirtinimo",
        "Legacy": "Legacy",
        "legacy model": "Legacy modelis",
        "legacy model_platform": "Legacy platforma",
        "legacy platform": "Legacy platforma",
        "license has expired": "Licencija nebegalioja",
        "loading": "Įkeliama",
        "log": "Žurnalas",
        "MainConfiguration": "",
        "main configuration": "Pagrindinė konfigūracija",
        "manual": "Rankinis",
        "ManualGeofenceList": "",
        "manual geofence list": "Rankiniu būdu sukurtų geozonos scenarijų sąrašas",
        "manual_geofence_list": "Rankiniu būdu sukurtų geozonos scenarijų sąrašas",
        "meig_modem_firmware": "MeiG modemo programinė įranga",
        "menu": "Meniu",
        "modem version": "Modemo versija",
        "netprisma_modem_firmware": "NETPRISMA modemo programinė įranga",
        "nmea_log": "NMEA žurnalas",
        "no": "Ne",
        "no results": "Pradinių rezultatų nerasta",
        "no results description": "Kai tik duomenys bus įkelti į FOTA WEB, juos galėsite matyti čia",
        "not assigned": "Nepriskirta",
        "not assigned configuration_file_id": "Konfigūracija nepriskirta",
        "not assigned current_configuration": "Konfigūracija nepriskirta",
        "not assigned current_firmware": "Programinė įranga nepriskirta",
        "not assigned firmware_file_id": "Programinė įranga nepriskirta",
        "not assigned group_id": "Grupė nepriskirta",
        "not assigned model": "Modelis nepriskirtas",
        "not assigned spec_id": "Spec. ID nepriskirtas",
        "not assigned task_type": "Užduočių tipas nepriskirtas",
        "obd_chip_firmware": "FM OBD lusto programinė įranga",
        "obd chip firmware version": "OBD lusto programinės įrangos versija",
        "Offline": "Neprisijungęs",
        "offline licenses": "Offline licencijos",
        "Online": "Prisijungęs",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "arba",
        "other": "Kita",
        "Pending": "Laukiama",
        "Pending approval": "Laukiama patvirtinimo",
        "permission disabled": "Išjungta",
        "permission enabled": "Įjungta",
        "productCodes": "Užsakymų kodai",
        "psub": "Prenumeratos failas",
        "quectel_fw": "Quectel modemo programinė įranga (quectel_fw)",
        "quectel_modem_firmware": "Quectel modemo programinė įranga",
        "resend invite": "Pakartotinai išsiųskite kvietimą",
        "restricted": "Apribotas",
        "retry": "Kartoti",
        "roles": "Vaidmenys ir leidimai",
        "Running": "Vykdoma",
        "RxAutoscan": "Atsisiųsti autoscan CAN failą",
        "RxBlackBox": "Atsisiųsti Black Box",
        "RxBluetoothAuthorizationList": "Atsisiųsti Bluetooth autorizacijos sąrašą",
        "RxCanDebugLog": "Gauti CAN derinimo žurnalą",
        "RxCarrierExtractions": "Atsisiųsti Carrier ištraukas",
        "RxCarrierLoggerFiles": "Atsisiųsti Carrier temperatūros registravimo įrenginių failus",
        "RxConfiguration": "Atsisiųsti konfigūraciją",
        "RxCrashDump": "Gauti strigčių išklotinės žurnalą",
        "RxExceptionInfo": "Atsisiųsti gedimo informaciją",
        "RxLog": "Atsisiųsti žurnalo failus",
        "RxManualGeofenceList": "Atsisiųsti rankiniu būdu sukurtų geozonos scenarijų sąrašą",
        "RxNmeaLog": "Atsisiųsti NMEA žurnalo failus",
        "RxOneWireAuthorizationList": "Atsisiųsti 1-Wire autorizacijos sąrašą",
        "RxWdLog": "Atsisiųsti WD žurnalą",
        "select company": "Pasirinkti įmonę",
        "SetBindSim": "Susieti įrenginius su naudojamomis SIM kortelėmis",
        "SetBluetoothPassword": "Nustatyti Bluetooth slaptažodį",
        "SetDisableFeature": "Išjungti funkciją",
        "SetEnableFeature": "Įjungti funkciją",
        "SetForceLockSim": "Blokuoti SIM kortelę",
        "SetUnbindSim": "Atsieti įrenginius nuo SIM kortelių",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "Būsena",
        "task details": "Užduoties informacija",
        "task groups": "Užduočių grupės",
        "tasks": "Užduočių grupės",
        "tasksCompatibility": "Užduočių suderinamumas",
        "task type": "Užduoties tipas",
        "Tct": "",
        "time zone": "Laiko juosta",
        "total": "Viso",
        "tutorials": "Mokomieji vadovai",
        "TxAdasFirmware": "Įkelti ADAS programinę įrangą",
        "TxAgpsMt3333": "Persiųsti AGPSM failą",
        "TxAgpsQuectelL89": "Persiųsti AGPSQ failą",
        "TxAutoscanCanConfiguration": "Įkelti autoscan OEM failą",
        "TxBleFirmware": "Įkelti BLE programinę įrangą",
        "TxBlueNrgFirmware": "Įkelti BlueNrg programinę įrangą",
        "TxBluetoothAuthorizationList": "Įkelti Bluetooth autorizacijos sąrašą",
        "TxBundleBle": "Įkelti BLE programinę įrangą",
        "TxBundleBleDtb": "Įkelti BLE DTB",
        "TxBundleCan": "Įkelti CAN programinę įrangą",
        "TxBundleCanDtb": "Įkelti CAN DTB",
        "TxBundleDtb": "Įkelti pagrindinį DTB",
        "TxBundleFirmware": "Įkelti pagrindinę programinę įrangą",
        "TxCanAdapterModeChange": "Pakeisti išorinio CAN priedo tipą",
        "TxCanAdapterModeChangeInternal": "Pakeisti vidinio CAN priedo tipą",
        "TxCanAdapterUpdate": "Įkelti CAN priedo programinę įrangą",
        "TxCanAdapterUpdateInternal": "Atnaujinti vidinio CAN priedo prog. įrangą",
        "TxCanChipFirmware": "Įkelti FMXY50 CAN lusto programinę įrangą",
        "TxCanConfiguration": "Įkelti OEM failą",
        "TxCarrierAdvanceFirmware": "Atnaujinti Carrier Advance prog. įrangą",
        "TxCarrierAdvanceSettings": "Atnaujinti Carrier Advance nuostatas",
        "TxCarrierApxFirmware": "Atnaujinti Carrier APX programinę įrangą",
        "TxCarrierApxSettings": "Atnaujinti Carrier APX nuostatas",
        "TxConfiguration": "Įkelti konfigūraciją",
        "TxDsmFirmware": "Įkelti DSM programinę įrangą",
        "TxDtb": "Įkelti DTB",
        "TxFirmware": "Įkelti programinę įrangą",
        "TxFirmwareBundle": "Įkelti programinės įrangos paketo konteinerį",
        "TxFirmwareBundleParts": "Įkelti programinės įrangos paketą",
        "TxFotaCertificate": "Atnaujinti FOTA sertifikatą",
        "TxGenericFile": "Įkelti bendrąjį failą",
        "TxGNSSMDownloadAssistant": "Įkelti GNSS-M Download Assistant prog. įrangą",
        "TxGNSSMFirmware": "Įkelti GNSS-M programinę įrangą",
        "TxManualGeofenceList": "Įkelti rankiniu būdu sukurtų geozonos scenarijų sąrašą",
        "TxMeigModemDeltaFirmware": "Įkelti MeiG Delta modemo programinę įrangą",
        "TxNetprismaModemDeltaFirmware": "Įkelti NETPRISMA Delta modemo programinę įrangą",
        "TxObdChipFirmware": "Atnaujinti OBD lusto programinę įrangą",
        "TxObdConfig": "Persiųsti OBD konfigūraciją",
        "TxOneWireAuthorizationList": "Įkelti 1-Wire autorizacijos sąrašą",
        "TxPSub": "Persiųsti prenumeratos failą",
        "TxQuectelModemDeltaFirmware": "Įkelti Quectel Delta modemo programinę įrangą",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "Įkelti naudotojo TLS sertifikatą",
        "users": "Naudotojai",
        "Unknown": "Nežinoma",
        "unknown": "Nežinoma",
        "unknown model_platform": "Nežinoma platforma",
        "unknown origin": "",
        "unknown platform": "Nežinoma platforma",
        "unrestricted": "Neapribotas",
        "Verifying": "Tikrinama",
        "vin": "VIN",
        "vip status": "VIP statusas",
        "wd_log": "WD žurnalas",
        "yes": "Taip"
    },
    "Maintenance": {
        "title": "Palaukite! Atliekama techninė priežiūra."
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} nepavyko dėl serverio klaidos.",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "Neturite leidimo atšaukti visų pasirinktų užduočių. Kai kurios užduotys yra susijusios su skirtingų įmonių ištekliais.",
            "Cancel tasks action failed. No resources found.": "Jokios užduotys neatitiko jūsų pasirinkimo. Peržiūrėkite užduočių pasirinkimą ir bandykite dar kartą.",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "Įmonė „{{SourceCompanyName}}“ ({{SourceCompanyId}}) susijungė su „{{TargetCompanyName}}“ ({{TargetCompanyId}}).",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "Įmonių sujungimas nepavyko. Įmonių \"{{SourceCompanyId}}\" ir \"{{TargetCompanyId}}\" negalima sujungti dėl nesuderinamų nustatymų ar leidimų.",
            "Create device group tasks action failed. No resources found.": "Nepavyko sukurti užduočių Smart Group. Prašome pabandyti iš naujo priskirti failą.",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "{{CreatedTaskCount}} užduotis(-ys), sukurta(-os) įrenginių grupės ID: {{GroupId}} įrenginiams.",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "Neturite leidimo sukurti užduočių visiems pasirinktiems įrenginiams. Kai kurie įrenginiai priklauso skirtingoms įmonėms.",
            "Create tasks action failed. No resources found.": "Jokie įrenginiai neatitiko jūsų pasirinkimo. Peržiūrėkite įrenginių pasirinkimą ir bandykite dar kartą.",
            "Create tasks action failed. No resources processed.": "Nepavyko apdoroti pasirinktų įrenginių. Pabandykite sukurti užduočių grupę dar kartą.",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "Neturite leidimo ištrinti visų pasirinktų įmonių. Kai kurios įmonės nėra tiesiogiai jūsų valdomos.",
            "Delete companies action failed. No resources found.": "Jokios įmonės neatitiko jūsų pasirinkimo. Peržiūrėkite įmonių pasirinkimą ir bandykite dar kartą.",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "Neturite leidimo ištrinti visų pasirinktų failų. Kai kurie failai yra susiję su skirtingų įmonių ištekliais.",
            "Delete files action failed. No resources found.": "Jokie failai neatitiko jūsų pasirinkimo. Peržiūrėkite failų pasirinkimą ir bandykite dar kartą.",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "Neturite leidimo ištrinti visų pasirinktų įrenginių grupių. Kai kuriose įrenginių grupėse yra išteklių iš skirtingų įmonių.",
            "Delete groups action failed. No resources found.": "Jokios įrenginių grupės neatitiko jūsų pasirinkimo. Peržiūrėkite įrenginių grupių pasirinkimą ir bandykite dar kartą.",
            "Delete product codes action failed. No resources found.": "Jokie užsakymų kodai neatitiko jūsų pasirinkimo. Peržiūrėkite užaskymų kodų pasirinkimą ir bandykite dar kartą.",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "Neturite leidimo ištrinti visų pasirinktų naudotojų. Kai kurie naudotojai priklauso skirtingoms įmonėms.",
            "Delete users action failed. No resources found.": "Jokie naudotojai neatitiko jūsų pasirinkimo. Peržiūrėkite naudotojų pasirinkimą ir bandykite dar kartą.",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "Įrenginių grupės ID: {{GroupId}} perkėlimas nepavyko. Tikslinės įmonės ID: {{TargetCompanyId}} nerasta.",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "Įrenginių grupės ID: {{GroupId}} sėkmingai perkeltas į įmonės ID: {{TargetCompanyId}}.",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{Filename}} išeksportuota įrenginių: {{DevicesCount}}.",
            "{{DevicesCount}} device(s) imported.": "Importuota įrenginių: {{DevicesCount}}.",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "Apdoroti įrenginiai: {{DevicesProcessedCount}}. Sukurtos užduotys: {{TasksCreatedCount}}.",
            "Export devices action failed. No resources found.": "Jokie įrenginiai neatitiko jūsų pasirinkimo. Peržiūrėkite įrenginių pasirinkimą ir bandykite dar kartą.",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "Užduočių grupėje ({{BatchId}}) grąžintos užduotys į laukiančią būseną: {{FailedTaskCount}}.",
            "Invalid request scope. Resources must belong to single root.": "Netinkama užklausos apimtis. Ištekliai turi priklausyti vienai motininei įmonei.",
            "Move device group action failed. No resources found.": "Jokios įrenginių grupės neatitiko jūsų pasirinkimo. Peržiūrėkite įrenginių grupių pasirinkimą ir bandykite dar kartą.",
            "{{ProcessedCount}} companies deleted.": "Ištrintos kompanijos: {{ProcessedCount}}.",
            "{{ProcessedCount}} device group(s) deleted.": "Ištrintos įrenginių grupės: {{ProcessedCount}}.",
            "{{ProcessedCount}} device attribute(s) updated.": "Atnaujinti Įrenginių atributai: {{ProcessedCount}}.",
            "{{ProcessedCount}} device model(s) deleted.": "Ištrinti įrenginių modeliai: {{ProcessedCount}}.",
            "{{ProcessedCount}} device(s) updated.": "Atnaujinti įrenginiai: {{ProcessedCount}}.",
            "{{ProcessedCount}} file(s) deleted.": "Ištrinti failai: {{ProcessedCount}}.",
            "{{ProcessedCount}} product code(s) deleted.": "Ištrinti užsakymų kodai: {{ProcessedCount}}.",
            "{{ProcessedCount}} task(s) canceled.": "Atšauktos užduotys: {{ProcessedCount}}.",
            "{{ProcessedCount}} task(s) updated.": "Atnaujintos užduotys: {{ProcessedCount}}.",
            "{{ProcessedCount}} user(s) deleted.": "Ištrinti naudotojai: {{ProcessedCount}}.",
            "Retry tasks action failed. No resources found.": "Jokios užduotys neatitiko jūsų pasirinkimo. Peržiūrėkite užduočių pasirinkimą ir bandykite dar kartą.",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "Neturite leidimo perkelti visų pasirinktų įrenginių. Kai kurie įrenginiai priklauso skirtingoms įmonėms.",
            "Transfer devices action failed. No resources found.": "Jokie įrenginiai neatitiko jūsų pasirinkimo. Peržiūrėkite įrenginių pasirinkimą ir bandykite dar kartą.",
            "Transfer devices action failed. No resources processed.": "Nepavyko apdoroti pasirinktų įrenginių. Pabandykite perkelti įrenginius dar kartą.",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "Perkelti įrenginiai: {{TransferredDevicesCount}} iš {{TotalDevicesToTransfer}}.",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "Neturite leidimo atnaujinti visų pasirinktų įrenginių. Kai kurie įrenginiai yra susiję su skirtingų įmonių ištekliais.",
            "Update devices action failed. No resources found.": "Jokie įrenginiai neatitiko jūsų pasirinkimo. Peržiūrėkite įrenginių pasirinkimą ir bandykite dar kartą.",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "Neturite leidimo atnaujinti visų pasirinktų įrenginių atributų. Kai kurie įrenginiai priklauso skirtingoms įmonėms.",
            "Update devices attributes action failed. No resources found.": "Jokie įrenginiai neatitiko jūsų pasirinkimo. Peržiūrėkite įrenginių pasirinkimą ir bandykite dar kartą.",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "Neturite leidimo atnaujinti visų pasirinktų užduočių. Kai kurios užduotys yra susijusios su skirtingų įmonių ištekliais.",
            "Update tasks action failed. No resources found.": "Jokios užduotys neatitiko jūsų pasirinkimo. Peržiūrėkite užduočių pasirinkimą ir bandykite dar kartą.",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": "Naudotojo prieigos galiojimas baigsis {{ExpiresAt}} UTC. Norėdami užtikrinti nepertraukiamą paslaugos teikimą, nedelsdami susisiekite su savo įmonės administratoriais ir paprašykite pratęsti prieigos galiojimą."
        },
        "no notifications": "Pranešimų nėra",
        "notifications": "Pranešimai",
        "notifications will be listed": "Visi nauji pranešimai bus rodomi čia",
        "remove notification": "Pašalinti pranešimą",
        "see previous notifications": "Žiūrėti ankstesnius pranešimus",
        "timestamps": {
            "days ago": "Prieš {{days}} d.",
            "hours ago": "Prieš {{hours}} val.",
            "minutes ago": "Prieš {{minutes}} min.",
            "moments ago": "Prieš kelias akimirkas"
        },
        "title": {
            "BackgroundActionFailed": "Veiksmas nepavyko",
            "CompaniesSuccessfullyDeleted": "Įmonės sėkmingai pašalintos",
            "CompanyBulkDeleteFailed": "Šalinant įmones įvyko klaida",
            "CompanyLevelChanged": "Įmonės lygis pakeistas",
            "CompanyLevelDowngradeReminder": "Artėjantis įmonės lygio sumažinimas",
            "CompanyMergeFailed": "Jungiant įmones įvyko klaida",
            "CompanySuccessfullyMerged": "Įmonės sėkmingai sujungtos",
            "DeviceAttributesSuccessfullyUpdated": "Įrenginio atributai sėkmingai atnaujinti",
            "DeviceBulkAttributeUpdateFailed": "Atnaujinant įrenginio atributus įvyko klaida",
            "DeviceBulkUpdateFailed": "Atnaujinant įrenginius įvyko klaida",
            "DeviceExportFailed": "Eksportuojant įrenginius įvyko klaida",
            "DeviceGroupMoveFailed": "Perkeliant įrenginių grupę įvyko klaida",
            "DeviceGroupsSuccessfullyDeleted": "Įrenginių grupės sėkmingai pašalintos",
            "DeviceGroupSuccessfullyMoved": "Įrenginių grupė sėkmingai perkelta",
            "DeviceGroupTasksCreateFailed": "Kuriant Smart Group užduotis įvyko klaida",
            "DeviceGroupTasksSuccessfullyCreated": "Smart Group užduotys sėkmingai sukurtos",
            "DeviceModelBulkDeleteFailed": "Šalinant įrenginių modelius įvyko klaida",
            "DeviceModelsSuccessfullyDeleted": "Įrenginių modeliai sėkmingai pašalinti",
            "DevicesSuccessfullyTransferred": "Įrenginiai sėkmingai perduoti",
            "DevicesSuccessfullyUpdated": "Įrenginiai sėkmingai atnaujinti",
            "DeviceTransferFailed": "Perduodant įrenginius įvyko klaida",
            "ExportFailed": "Išteklių eksportavimas nepavyko",
            "ExportSucceeded": "Įrenginiai sėkmingai eksportuoti",
            "FailedTasksRetryFailed": "Kartojant nepavykusias užduotis įvyko klaida",
            "FailedTasksSuccessfullyRetried": "Nepavykusios užduotys sėkmingai pakartotos",
            "FileBulkDeleteFailed": "Šalinant failus įvyko klaida",
            "FilesSuccessfullyDeleted": "Failai sėkmingai pašalinti",
            "GroupBulkDeleteFailed": "Šalinant įrenginių grupes įvyko klaida",
            "ImportFailed": "Išteklių importavimas nepavyko",
            "ImportSucceeded": "Įrenginiai sėkmingai importuoti",
            "ProductCodeBulkDeleteFailed": "Šalinant užsakymų kodus įvyko klaida",
            "ProductCodesSuccessfullyDeleted": "Užsakymų kodai sėkmingai pašalinti",
            "ResourceUpdateFailed": "Išteklių atnaujinimas nepavyko",
            "ResourceUpdateSucceeded": "Išteklių atnaujinimas pavyko",
            "RoleBulkDeleteFailed": "Šalinant vaidmenis įvyko klaida",
            "RolesSuccessfullyDeleted": "Vaidmenys sėkmingai pašalinti",
            "TaskBulkCancelFailed": "Atšaukiant užduotis įvyko klaida",
            "TaskBulkCreateFailed": "Kuriant užduočių grupę įvyko klaida",
            "TaskBulkUpdateFailed": "Atnaujinant užduotis įvyko klaida",
            "TaskGroupSuccessfullyCreated": "Užduočių grupė sėkmingai sukurta",
            "TasksPropagationFailed": "Nepavyko įvykdyti užduočių paskirstymo užduoties",
            "TasksPropagationSucceeded": "Pavyko įvykdyti užduočių paskirstymo užduotį",
            "TasksPropagationWarning": "Užduočių paskirstymo užduotis buvo įvykdyta su įspėjimais",
            "TasksSuccessfullyCanceled": "Užduotys sėkmingai atšauktos",
            "TasksSuccessfullyUpdated": "Užduotys sėkmingai atnaujintos",
            "UserBulkDeleteFailed": "Šalinant naudotojus įvyko klaida",
            "UserExpireReminder": "Jūsų FOTA WEB prieiga netrukus baigsis",
            "UsersSuccessfullyDeleted": "Naudotojai sėkmingai pašalinti"
        }
    },
    "Permission actions": {
        "Access": "TCT integracija",
        "Create": "Kūrimas",
        "Delete": "Šalinimas",
        "Download": "Atsisiuntimas",
        "Export": "Eksportavimas",
        "Merge": "Sujungimas",
        "Read": "Skaitymas",
        "Retry": "Kartojimas",
        "SecretsRead": "Slaptažodžiai",
        "TctWebAccess": "TCT web",
        "Transfer": "Perdavimas",
        "Unlock": "Atrakinimas",
        "Update": "Atnaujinimas"
    },
    "Permission groups": {
        "company": "Įmonės",
        "device": "Įrenginiai",
        "device group": "Įrenginių grupės",
        "file": "Failai",
        "role": "Vaidmenys",
        "task": "Užduotys",
        "task group": "Užduočių grupės",
        "token": "API prieigos raktai",
        "user": "Naudotojai"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "Ši parinktis išjungta naudotojams, turintiems pagrindinį įmonės lygį.",
                "token list": "API integracijos prieigos raktai yra išjungti naudotojams, turintiems pagrindinį įmonės lygį."
            },
            "custom_role_support": {
                "create role": "Šią funkciją gali naudoti tik premium įmonės lygių naudotojai.",
                "edit role": "Šią funkciją gali naudoti tik premium įmonės lygių naudotojai. Anksčiau sukurti vaidmenys gali būti trinami.",
                "edit user": "Šią funkciją gali naudoti tik premium įmonės lygių naudotojai. Anksčiau priskirti vaidmenys gali būti šalinami."
            },
            "task_schedule_support": {
                "table head": "Šią funkciją gali naudoti tik standartinio ir premium įmonės lygių naudotojai. Anksčiau pridėtos užduotys su suplanuotu laiku vis tiek bus vykdomos."
            }
        },
        "general message": "Šią funkciją gali naudoti tik standartinio ir premium įmonės lygių naudotojai.",
        "resource_limit_settings": {
            "tasks_per_group": "Vienu metu negalite sukurti užduočių daugiau nei {{limitCount}} įrenginių."
        }
    },
    "Search": {
        "code": "Kodas",
        "description": "Aprašymas",
        "email": "El. paštas",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "model": "Modelis",
        "name": "Pavadinimas",
        "product code": "Užsakymo kodas",
        "role name": "Vaidmens pavadinimas",
        "serial": "Serijos Nr.",
        "search by": "Paieška pagal",
        "search company name": "Ieškoti įmonės pavadinimo"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "Ketinate išjungti dviejų dalių autentifikavimą. Dėl to jūsų FOTA WEB paskyra gali tapti nesaugia. Ar tikrai norite tęsti?",
                    "title": "Ar esate tuo tikri?"
                },
                "send email code": {
                    "enter code": "Saugumo sumetimais įveskite kodą, kad patvirtintumėte el. paštą."
                },
                "send otp code": {
                    "description": "6 skaitmenų kodas išsiųstas į jūsų autentifikavimo mobiliąją programėlę. Saugumo sumetimais, įveskite sugeneruotą kodą į žemiau esantį laukelį.",
                    "no access": {
                        "authenticator": "Jei nebeturite prieigos prie su šia paskyra susietos autentifikavimo mobiliosios programėlės, norint išjungti dviejų dalių autentifikavimą, pasikeiskite slaptažodį.",
                        "email": "Jei nebeturite prieigos prie el. pašto, susieto su šia paskyra, ir norite išjungti dviejų dalių autentifikavimą - pasikeiskite slaptažodį."
                    }
                },
                "title": "Išjungti dviejų dalių autentifikavimą"
            },
            "get email code": {
                "description": "Norėdami patvirtinti paskyrą, naudokite tą kodą kitame žingsnyje.",
                "description modal": "Naudokite šį kodą paskyrai patvirtinti.",
                "title": "Paspaudus \"Siųsti kodą\", unikalus kodas bus išsiųstas adresu <1>{{email}}</1>."
            },
            "get secret code": {
                "description": "Norėdami užbaigti šį procesą, jums reikės autentifikavimo mobiliosios programėlės, pvz., vienos iš šių:"
            },
            "select authentication type": {
                "authentication app description": "Gaukite unikalų kodą iš programėlės, pvz., \"Microsoft Authenticator\", ar \"Google Authenticator\".",
                "description": "Norėdami apsaugoti savo paskyrą ir kliento duomenis, pasirinkite vieną iš šių parinkčių, kad įjungtumėte dviejų dalių autentifikavimą.",
                "description modal": "Pasirinkite pageidaujamą autentifikavimo būdą.",
                "email": "El. paštas",
                "email description": "Kiekvieną kartą jungiantis, į el. paštą išsiųsime vienkartinį kodą.",
                "recommended": "Rekomenduojama",
                "title": "Dviejų dalių autentifikavimas (2FA) yra privalomas visiems FOTA WEB naudotojams.",
                "title modal": "Pasirinkite autentifikavimo būdą"
            },
            "send email code": {
                "description": "Įveskite kodą į žemiau esantį laukelį ir paspauskite \"Patvirtinti\", kad tęstumėte.",
                "enter code": "Įveskite kodą, kad patvirtintumėte el. paštą.",
                "title": "Unikalus kodas buvo išsiųstas adresu <1>{{email}}</1>.",
                "verification code": "Patvirtinimo kodas"
            },
            "send otp code": {
                "click to scan code": "Spauskite čia, jei norite nuskaityti QR kodą",
                "click to type code": "Spauskite čia, jei norite rankiniu būdu įvesti kodą",
                "incorrect code": "Neteisingas kodas",
                "scan QR code": "Nuskaitykite QR kodą į savo programėlę",
                "six digit code": "6 skaitmenų kodas, sugeneruotas jūsų programėlės",
                "title": "Norėdami užbaigti šį procesą, jums reikės autentifikavimo mobiliosios programėlės, pvz., <1>\"Microsoft Authenticator\"</1> arba <2>\"Google Authenticator\"</2>.",
                "type text code": "Įveskite kodą į savo programėlę"
            },
            "settings": {
                "description": "Dviejų dalių autentifikavimas yra papildomas saugos sluoksnis, patvirtinantis jūsų tapatybę naudojant ką nors, ką žinote (slaptažodis) ir ką nors, ką turite (telefonas, saugos raktas, el. paštas).",
                "disabled": "Išjungtas",
                "enabled": "Įjungtas",
                "title": "Dviejų dalių autentifikavimas"
            },
            "success message": {
                "alert": "Sėkmingai įjungėte dviejų dalių autentifikavimą.",
                "description": "Mes paprašysime autentifikavimo kodo kiekvieną kartą, kai prisijungsite naudodami save el. pašto adresą ir slaptažodį.",
                "title": "Sėkmingai įjungėte dviejų dalių autentifikavimą.",
                "title modal": "Dviejų dalių autentifikavimas įjungtas!"
            },
            "title": {
                "authentication app": "Autentifikavimas mobiliąja programėle",
                "authentication email": "Autentifikavimas el. paštu",
                "is enabled": "Dviejų dalių autentifikavimas įjungtas.",
                "protect your account": "Apsaugokite savo FOTA WEB paskyrą"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "Pakeisti slaptažodį",
            "enter current password": "Įveskite dabartinį slaptažodį",
            "enter new password": "Įveskite naują slaptažodį",
            "hide password": "Slėpti slaptažodį",
            "repeat new password": "Pakartotinai įveskite naują slaptažodį",
            "rules": {
                "lowercase letter": "Bent viena mažoji raidė (a-z)",
                "minimum characters": "Bent 12 simbolių",
                "new and current passwords must not match": "Naujas ir dabartinis slaptažodžiai turi skirtis",
                "new passwords must match": "Nauji slaptažodžiai turi sutapti",
                "number": "Bent vienas skaičius",
                "passwords must match": "Slaptažodžiai turi sutapti",
                "special symbol": "Bent vienas specialus simbolis (!@#$%^&*()-_=+)",
                "uppercase letter": "Bent viena didžioji raidė (A-Z)"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "Rodyti slaptažodį"
        },
        "recovery codes": {
            "banner description": "Šie kodai bus rodomi tik vieną kartą. Išsaugokite juos saugioje vietoje – pavyzdžiui, slaptažodžių tvarkyklėje, atspausdintą kopiją saugioje vietoje arba užšifruotame faile.",
            "banner title": "Išsaugokite kodus.",
            "checkbox title": "Aš išsaugojau savo atkūrimo kodus.",
            "download error message": "Nepavyko apdoroti kodų. Duomenų formatas yra neteisingas.",
            "first step description": "6 skaitmenų kodas išsiųstas į jūsų autentifikavimo mobiliąją programėlę. Saugumo sumetimais, įveskite sugeneruotą kodą į žemiau esantį laukelį.",
            "first step title": "Generuoti atkūrimo kodus",
            "input field title": "Atkūrimo kodas",
            "print error message": "Nepavyko atidaryti spausdinimo lango. Prašome bandyti dar kartą arba patikrinti, ar jūsų naršyklė neblokuoja iškylančių langų.",
            "second step description": "Atkūrimo kodai leidžia atgauti prieigą prie paskyros, jei prarastumėte autentiškumo patvirtinimo įrenginį ar programėlę.",
            "second step title": "Dviejų faktorių atkūrimo kodai",
            "settings": {
                "title": "Generuoti atkūrimo kodus",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": "Versija"
    },
    "Statistics": {
        "table statistics": "Statistika",
        "statistics message": "Lentelėje pasirinkti filtrai atvaizduojami statistikoje",
        "activity": "Veikla",
        "model": "Modelis",
        "firmware": "Programinė įranga",
        "configuration": "Konfigūracija",
        "statistics": "Statistika"
    },
    "Table": {
        "1_wire_authorization": "1-Wire autorizacija",
        "access group": "",
        "access groups": "",
        "access level": "Prieigos lygis",
        "accessories": "Priedai",
        "action": "Veiksmas",
        "action date": "Veiksmo data",
        "assigned package": "Priskirtas paketas",
        "attempt count": "Bandymų skaičius",
        "attribute": "Atributas",
        "attributes": "Atributai",
        "auto sync": "",
        "batch id": "Paketo ID",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLE programinė įranga",
        "bluetooth_authorization": "Bluetooth autorizacija",
        "bootloader": "Bootloader",
        "can_adapter": "CAN priedas",
        "can adapter name": "CAN priedo pavadinimas",
        "can bootstring": "Bootstring",
        "can oem file package": "OEM failo paketas",
        "can oem file vehicle": "OEM failo transporto priemonė",
        "can package": "CAN paketas",
        "can program number": "CAN programos numeris",
        "can software date": "CAN programinės įrangos data",
        "can type": "CAN tipas",
        "carrier module id": "Modulio ID",
        "carrier revision": "Revizija",
        "carrier serial id": "Serijos ID",
        "carrier settings filename": "Nuostatų failas",
        "carrier unit status": "Būsena",
        "carrier unit type": "Tipas",
        "changed at": "Pakeista",
        "change origin": "",
        "changes": "Pasikeitimai",
        "checkbox disabled": {
            "role": "Statinio vaidmens negalima redaguoti ar ištrinti."
        },
        "child company": "<1>{{parentCompany}}</1><0>antrinė įmonė</0>",
        "child companies": "Antrinės įmonės",
        "code": "Kodas",
        "company": "Įmonė",
        "company hierarchy": "Įmonės hierarchija",
        "company name": "Įmonės pavadinimas",
        "compatibility": "Suderinamumas",
        "configuration": "Konfigūracija",
        "configuration details": "Konfigūracijos informacija",
        "configuration type": "",
        "created at": "Sukurta",
        "created by": "Sukūrė",
        "date": "Data",
        "description": "Aprašymas",
        "device details": "Įrenginio informacija",
        "device company": "Įrenginio įmonė",
        "device description": "Įrenginio aprašymas",
        "device group": "Įrenginio grupė",
        "device imei": "Įrenginio IMEI",
        "device model": "Įrenginio modelis",
        "device seen at": "Prietaisas jungėsi",
        "device serial": "Įrenginio serijos Nr.",
        "devices": "Įrenginiai",
        "devices count": "Įrenginių skaičius",
        "Done": "Baigta",
        "download at": "",
        "download file": "Atsisiųsti failą",
        "dtb": "DTB",
        "edit file": "Redaguoti failą",
        "edit group banner": "Jei įrenginys pridedamas prie grupės, kuriai nustatyta programinė įranga ir (arba) konfigūracija, visos ankstesnės to paties tipo užduotys, kurių vykdymas dar nebuvo užbaigtas, bus atšauktos.",
        "email": "El. paštas",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "Kai tik bus sukurtos užduočių grupės, jų sąrašą galėsite matyti čia",
                    "changes": "Kai tik bus atlikti pakeitimai, jų sąrašą galėsite matyti čia",
                    "companies": "Kai tik bus sukurtos įmonės, jų sąrašą galėsite matyti čia",
                    "configurationChanges": "",
                    "desktopLicenses": "Kai tik bus sukurtos desktop licencijos, jų sąrašą galėsite matyti čia",
                    "devices": "Kai tik įrenginiai bus įkelti į FOTA WEB, jų sąrašą galėsite matyti čia",
                    "files": "Kai tik bus įkelti failai, jų sąrašą galėsite matyti čia",
                    "groups": "Kai tik bus sukurtos grupės, jų sąrašą galėsite matyti čia",
                    "offlineLicenses": "Kai tik bus sukurtos offline licencijos, jų sąrašą galėsite matyti čia",
                    "permissions": "Kai tik naudotojui bus priskirti leidimai, jų sąrašą galėsite matyti čia",
                    "productCodes": "Kai tik bus sukurti užsakymų kodai, jų sąrašą galėsite matyti čia",
                    "roles": "Kai tik bus sukurti vaidmenys, jų sąrašą galėsite matyti čia",
                    "tasks": "Kai tik bus sukurtos užduotys, jų sąrašą galėsite matyti čia",
                    "users": "Kai tik bus pridėti naudotojai, jų sąrašą galėsite matyti čia"
                },
                "title": {
                    "batches": "Užduočių grupių lentelė tusčia",
                    "changes": "Pakeitimų lentelė tuščia",
                    "companies": "Įmonių lentelė tuščia",
                    "configurationChanges": "",
                    "desktopLicenses": "Desktop licencijų lentelė tuščia",
                    "devices": "Įrenginių lentelė tuščia",
                    "files": "Failų lentelė tuščia",
                    "groups": "Grupių lentelė tuščia",
                    "offlineLicenses": "Offline licencijų lentelė tuščia",
                    "permissions": "Leidimų lentelė tuščia",
                    "productCodes": "Užsakymų kodų lentelė tuščia",
                    "roles": "Vaidmenų lentelė tuščia",
                    "tasks": "Užduočių lentelė tuščia",
                    "users": "Naudotojų lentelė tuščia"
                }
            },
            "no permission": {
                "description": "Norėdami gauti prieigą, susisiekite su savo administratoriumi.",
                "title": "Neturite reikiamo leidimo peržiūrėti šio turinio"
            },
            "no results found": {
                "description": "Išbandykite kitą raktinį žodį arba filtrą, kad gautumėte daugiau rezultatų",
                "title": "Rezultatų nerasta"
            },
            "button": {
                "add": {
                    "companies": "Kurti įmonę",
                    "devices": "Pridėti įrenginį",
                    "files": "Įkelti failą",
                    "groups": "Kurti grupę",
                    "productCodes": "Pridėti užsakymo kodą",
                    "tasks": "Kurti užduotį",
                    "users": "Pakviesti naudotoją"
                },
                "reset view": "Atkurti pradinį vaizdą"
            }
        },
        "exausted autoscan limit": "Autoscan limitas iki",
        "exausted vin parsing limit": "VIN limitas iki",
        "expiration": "Galiojimas",
        "expiration date": "Galiojimo data",
        "expires at": "Galioja iki",
        "expiry date": "Galiojimo laikas",
        "field": "Laukelis",
        "file": "Failas",
        "file id": "Failo ID",
        "files": "Failai",
        "file type": "Failo tipas",
        "filter by": "Filtruoti pagal",
        "firmware": "Programinė įranga",
        "general": "Bendra informacija",
        "general data": "Bendrieji duomenys",
        "gnss version": "GNSS versija",
        "group": "Grupė",
        "groups": "Įrenginių grupės",
        "group vip status": "Grupės VIP statusas",
        "gsm number": "GSM numeris",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": ""
            },
            "platform": {
                "fmx platform": "<1>FMx platforma</1> - FMx (FMB, FMU, FMC, FMM), FMT, FMP, TAT, MSP, TFT, TST, GH (GH5200) ir TMT modeliai.",
                "ft platform": "<1>FT platforma</1> - FTx ir ATx modeliai.",
                "legacy platform": "<1>Legacy platforma</1> - FM (išskyrus FM4001 ir FM3010), FMA, ir GH (GH4000) modeliai.",
                "title": "Telematikos įrenginio platformos generavimas"
            },
            "visibility": "<2>Pakeitimai, pažymėti kaip <1>Vidiniai</1>, klientams nematomi.</2><2>Kadangi įrenginių pakeitimai gali apimti tiek matomus, tiek paslėptus duomenis, <1>išoriniuose susirašinėjimuose nedalykite ekrano kopijų ar detalių</1>.</2>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "Informacija",
        "interface": "Jungtis",
        "invited by": "Pakvietė",
        "items": "elementai",
        "last checked at": "Paskutinį kartą tikrinta",
        "last sign in": "Paskutinį kartą prisijungta",
        "last status update": "Paskutinis būsenos atnaujinimas",
        "last used at": "Paskutinį kartą naudotas",
        "license disabled": "Išjungta",
        "license enabled": "Įjungta",
        "license key": "Licencijos raktas",
        "license name": "Licencijos pavadinimas",
        "links": "Nuorodos",
        "manual_geofence_scenarios": "Rankiniu būdu sukurti geozonos scenarijai",
        "message": "Pranešimas",
        "model": "Modelis",
        "model task type support": {
            "false": "Nepalaiko",
            "true": "Palaiko"
        },
        "modem version": "Modemo versija",
        "name": "Pavadinimas",
        "new value": "Nauja vertė",
        "next task": "Kita užduotis",
        "no changes": "Pakeitimų nėra.",
        "no company name": "Įmonės pavadinimo nėra",
        "no details": "Informacijos nėra",
        "no file": "Nėra failo",
        "no imei available": "Nėra IMEI",
        "no model": "Modelio nėra",
        "no parent company": "Įmonė neturi patronuojančiosios įmonės.",
        "no tasks": "Įrenginys užduočių neturi.",
        "number": "Numeris",
        "obd": "OBD",
        "obd chip firmware version": "OBD lusto programinės įrangos versija",
        "of": "iš",
        "offline licenses tab disabled": "Offline licencijos nepsakiekiamos, jei dekstop licencija išjungta.",
        "original value": "Pradinė vertė",
        "other information": "Kita informacija",
        "page of": "puslapis iš",
        "parent company": "Patronuojančioji įmonė",
        "permission count": "Leidimų kiekis",
        "platform": "Platforma",
        "Price": "Kaina",
        "product code": "Užsakymo kodas",
        "program number": "Programos numeris",
        "property": "Parametras",
        "queue": "Eilė",
        "receiving company": "Priimančioji įmonė",
        "revision": "Revizija",
        "role": "Vaidmuo",
        "role name": "Vaidmens pavadinimas",
        "rows per page": "Eilučių puslapyje",
        "running": "Vykdoma",
        "schedule": "Suplanuotas laikas",
        "seen at": "Jungėsi",
        "select row": "Pažymėkite eilutę, kad pamatytumėte išsamią informaciją",
        "send sms": "Siųsti SMS",
        "serial": "Serijos Nr.",
        "show details": {
            "desktopLicenses": "Rodyti desktop licencijos informaciją",
            "devices": "Rodyti įrenginio informaciją",
            "batches": "Rodyti užduoties grupės informaciją",
            "tasks": "Rodyti užduoties informaciją",
            "companies": "Rodyti įmonės informaciją"
        },
        "sim": "SIM",
        "size": "Dydis",
        "software date": "Programinės įrangos data",
        "source company": "Šaltinio įmonė",
        "spec_id": "Spec. ID",
        "status": "Būsena",
        "status id": "Būsenos ID",
        "status name": "Būsena",
        "supported task types": "Palaikomi užduočių tipai",
        "synced at": "",
        "table columns": "Lentelės stulpeliai",
        "target company": "Tikslinė įmonė",
        "task id": "Užduoties ID",
        "task queue": "Užduočių eilė",
        "tasks": "Užduotys",
        "task type": "Užduoties tipas",
        "tct web support": "TCT web palaikymas",
        "total": "Iš viso",
        "type": "Tipas",
        "updated at": "Atnaujinta",
        "updated by": "Atnaujino",
        "unknown": "Nežinoma",
        "user cannot be deleted": "Naudotojo negalima ištrinti.",
        "user cannot be edited": "Naudotojo negalima redaguoti.",
        "user cannot delete himself": "Naudotojas negali ištrinti savo profilio.",
        "user date statuses": {
            "expired": "Nebegalioja nuo",
            "expires": "Galioja iki",
            "never expires": "Galioja neribotai",
            "sent": "Išsiųsta"
        },
        "user email": "Naudotojo el. paštas",
        "user invitation cannot be cancelled": "Naudotojo kvietimo atšaukti negalima.",
        "user invitation cannot be resent": "Naudotojo kvietimo pakartotinai išsiųsti negalima.",
        "user statuses": {
            "Active": "Aktyvus",
            "Inactive": "Neaktyvus",
            "InvitationExpired": "Kvietimas nebegalioja",
            "InvitationPending": "Kvietimas laukia patvirtinimo"
        },
        "users": "Naudotojai",
        "value from": "Pakeista iš",
        "value to": "Pakeista į",
        "view all roles": "Visi vaidmenys ({{count}})",
        "vin": "VIN",
        "vip status": "VIP statusas",
        "visibility": "Matomumas"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "Paaiškinimas dėl nežinomo slaptažodžio",
            "disabled copy tooltip": "Atskleiskite slaptažodį, kad būtų galima kopijuoti",
            "unknown": "Nežinoma",
            "unknown tooltip": "„Nežinoma“ reiškia, kad slaptažodžio kilmė nėra užregistruota, paprastai dėl to, kad jis buvo nustatytas per TCT arba tiesiogiai gamybos metu."
        },
        "device group tasks": "Įrenginių grupės užduotys",
        "group tasks": "Grupinės užduotys",
        "number of devices": "Įrenginių skaičius",
        "permissions info": "Leidimų informacija",
        "smart group files": "Smart Group failai",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "priedo sąsajos pavadinimas.",
                    "type": "prijungto priedo tipas."
                },
                "can": {
                    "assigned package": "įrenginiui priskirtas OEM paketas.",
                    "can oem file package": "OEM paketas, apie kurį pranešta paskutinio prisijungimo metu.",
                    "can oem file vehicle": "OEM transporto priemonės konfigūracija, apie kurią pranešta paskutinio prisijungimo metu.",
                    "dtb": "paskutinio prisijungimo metu pateikta CAN įrenginio Device Tree Blob (DTB) versija.",
                    "firmware": "CAN programinės įrangos versija."
                },
                "can_adapter": {
                    "can adapter name": "Iš paleidimo eilutės išskaitytas CAN adapterio pavadinimas.",
                    "can bootstring": "Naujausia gauta CAN adapterio paleidimo eilutė, kurioje pateikiami dabartiniai duomenys ir adapterio programos numeris.",
                    "program number": "CAN adapterio programos numeris.",
                    "revision": "CAN adapterio programinės įrangos pataisos versijos data.",
                    "software date": "CAN adapterio programinės įrangos data.",
                    "type": "CAN adapterio tipas."
                },
                "configuration details": {
                    "1_wire_authorization": "paskutino išsiųsto 1-Wire autorizacijos sąrašo failo pavadinimas.",
                    "bluetooth_authorization": "paskutino išsiųsto Bluetooth autorizacijos sąrašo failo pavadinimas.",
                    "main configuration": "paskutinio išsiųsto pagrindinės konfigūracijos failo pavadinimas.",
                    "manual_geofence_scenarios": "paskutinio išsiųsto rankiniu būdu sukurtų geozonos sąrašo failo pavadinimas."
                },
                "general": {
                    "ble_dtb": "paskutinio prisijungimo metu pateikta BLE įrenginio Device Tree Blob (DTB) versija.",
                    "ble_fw": "BLE programinės įrangos versija, apie kurią pranešta paskutinio prisijungimo metu.",
                    "bluetooth password": "įrenginio Bluetooth slaptažodis, kuris gali būti atskleistas, kai slaptažodis nustatomas per FOTA WEB, naudotojams, turintiems „$t(General##Device.SecretsRead)“ leidimą.",
                    "bootloader": "įrenginio bootloader versija, apie kurią pranešta paskutinio prisijungimo metu.",
                    "company": "įmonė, kuriai priklauso šis įrenginys.",
                    "configuration": "paskutinis išsiųstas konfigūracijos failo pavadinimas.",
                    "description": "įrenginio aprašymas (nustatytas naudotojo).",
                    "dtb": "įrenginio DTB versija, apie kurią pranešta paskutinio prisijungimo metu.",
                    "firmware": "įrenginio programinės įrangos versija, apie kurią pranešta paskutinio prisijungimo metu.",
                    "gnss version": "GNSS versija, apie kurią pranešta paskutinio prisijungimo metu.",
                    "group": "įrenginių grupė, kuriai šis įrenginys priskirtas.",
                    "product code": "įrenginio užsakymo kodas.",
                    "serial": "įrenginio serijos numeris."
                },
                "obd": {
                    "obd chip firmware version": "OBD lusto programinės įrangos versija, apie kurią pranešta paskutinio prisijungimo metu.",
                    "vin": "unikalus 17 simbolių kodas, identifikuojantis konkrečią motorinę transporto priemonę."
                },
                "sim": {
                    "gsm number": "viešasis telefono numeris, susietas su įrenginiu.",
                    "iccid": "unikalus serijos numeris, identifikuojantis SIM kortelę.",
                    "imsi": "unikalus mobiliojo ryšio tinklo abonento identifikatorius."
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "konfigūracijos failas, skirtas FMx platformos įrenginiams, priskirtiems įrenginių grupei.",
                    "firmware": "įrenginių grupei priskirtų FMx platformos įrenginių programinės įrangos failas."
                },
                "ft platform files": {
                    "1_wire_authorization_list": "FT platformos įrenginių grupei priskirtų autorizuotų 1-Wire įrenginių failas.",
                    "bluetooth_authorization_list": "FT platformos įrenginiams, priskirtiems įrenginių grupei, patvirtintų Bluetooth įrenginių sąrašas.",
                    "firmware": "įrenginių grupei priskirtų FT platformos įrenginių programinės įrangos failas.",
                    "main configuration": "pagrindinis FT platformos įrenginių, priskirtų įrenginių grupei, konfigūracijos failas."
                }
            },
            "users": {
                "general": {
                    "created at": "naudotojo sukūrimo data ir laikas.",
                    "id": "unikalus naudotojo ID.",
                    "invited by": "kvietimą sukūrusio naudotojo el. pašto adresas.",
                    "role": "naudotojui priskirtas(-i) vaidmuo(-enys).",
                    "updated at": "naudotojo atnaujinimo data ir laikas."
                }
            }
        },
        "user details": "Naudotojo informacija"
    },
    "Task groups": {
        "all": "Visos",
        "bulk type": {
            "CompanyBulkDelete": "Naikinti įmonę",
            "DeviceBulkCreate": "Pridėti įrenginį",
            "DeviceBulkDelete": "Naikinti įrenginį",
            "DeviceBulkUpdate": "Atnaujinti įrenginį",
            "FileBulkDelete": "Naikinti failą",
            "GroupBulkDelete": "Naikinti grupę",
            "TaskBulkCreate": "Kurti užduotį",
            "TaskBulkUpdate": "Atšaukti užduotį",
            "UserBulkDelete": "Naikinti naudotoją"
        },
        "pending approval": "Laukiančios patvirtinimo",
        "already approved": "Patvirtintos",
        "no approval required": "Nereikalaujančios patvirtinimo",
        "total objects": "Iš viso objektų",
        "total tasks": "Iš viso užduočių"
    },
    "Task status": {
        "0": "Laukiama",
        "1": "Vykdoma",
        "2": "Baigta",
        "3": "Baigta su klaidomis",
        "4": "Nutraukta",
        "5": "Nepavyko",
        "6": "Nebegalioja",
        "7": "Laukiama patvirtinimo",
        "8": "Tikrinama",
        "task count": {
            "0": "Laukiančios užduotys",
            "1": "Vykdomos užduotys",
            "3": "Baigtos su klaidomis užduotys",
            "5": "Nepavykusios užduotys"
        },
        "verified tooltip title": "Užduotis sėkmingai baigta ir patikrinta įrenginio."
    },
    "Tasks": {
        "0": "Užduotis laukia eilėje.",
        "1": "Užduotis vykdoma.",
        "2": "Užduotis sėkmingai įvykdyta.",
        "3": "Užduotis baigta su klaidomis.",
        "4": "Užduotis atšaukta.",
        "5": "Užduotis nepavyko.",
        "6": "Baigėsi užduoties vykdymo laikas."
    },
    "Tct": {
        "edit configuration": "Redaguoti konfigūraciją",
        "no editable configurations": "Nėra jokių redaguojamų konfigūracijų",
        "open tct": "Atidaryti TCT web versiją",
        "open tct description": "Sukurkite naują konfigūraciją per TCT web arba redaguokite esamą konfigūracijos failą iš FOTA WEB.",
        "select configuration file": "Pasirinkite konfigūracijos failą, kurį norite redaguoti TCT web.",
        "tct web": "TCT web",
        "tct web disabled description": "TCT web skirtas tik Premium įmonės lygio naudotojams."
    },
    "Tutorial": {
        "buttons": {
            "exit": "Išeiti",
            "finish": "Baigti",
            "get started": "Pradėti",
            "next": "Toliau",
            "next feature": "Kitas funkcionalumas"
        },
        "content": {
            "company selector": {
                "0": "Viršutinėje navigacijos juostoje matysite įmonių pasirinkimo parinktį. Paspaudus mygtuką atsivers meniu, kuriame galėsite pasirinkti bet kokį skaičių įmonių, su kuriomis norite dirbti FOTA sistemoje.",
                "1": "Šiame ekrane galite pasirinkti konkrečią įmonę arba kelias įmones, su kuriomis norite dirbti. Matysite tik su pasirinktomis įmonėmis susijusius sąrašus. Atsijungus iš FOTA, visada bus išsaugotas paskutinis naudotas pasirinkimas.",
                "1-info": "\n\nJei norite pereiti prie kito funkcijos vadovo, spauskite mygtuką „$t(Tutorial##buttons##next feature)“."
            },
            "finish tutorial": "Baigėte vadovą. Jei bet kada norėsite jį peržiūrėti dar kartą, tai galėsite padaryti nustatymų lange.",
            "first time user": "Sveiki atvykę į FOTA WEB mokomojo režimo puslapį. Šiame režime mes supažindinsime jus su kai kuriomis naujomis FOTA WEB funkcijomis.\nJei norite išeiti iš mokomojo režimo, paspauskite mygtuką „$t(Tutorial##buttons##exit)“ ekrano apačioje. Jei bet kuriuo metu norėsite vėl pradėti mokomąjį režimą, galėsite tai padaryti nustatymuose.\n\nNorėdami pradėti, paspauskite mygtuką „$t(Tutorial##buttons##get started)“.",
            "task groups": {
                "desktop": {
                    "0": "Užduočių grupės yra kairėje navigacijos juostoje. Pasirinkus Užduočių grupės parinktį, pateksite į tą puslapį.",
                    "1": "Tai yra Užduočių grupių ekranas. Visos masinės užduotys, sukurtos daugiau nei vienam įrenginiui, bus rodomos lentelės peržiūroje kartu su kiekvienos užduoties būsena užduočių grupėje. Pasirinkus eilutę, galima peržiūrėti išsamesnę informaciją."
                },
                "mobile": {
                    "0": "Parinktį Užduočių grupės rasite meniu kartu su kitomis parinktimis.",
                    "1": "Atidarius meniu ir pasirinkus Užduočių grupės parinktį, pateksite į tą puslapį."
                }
            }
        },
        "titles": {
            "finish tutorial": "Mokomasis vadovas baigtas!",
            "first time user": "Sveiki atvykę į FOTA WEB.",
            "tutorial mode": "Mokomojo vadovo režimas"
        }
    }
}
